export const getjson = function(obj,type) {
    
    var data='',list=[];
    if(obj=='vehicle')
    {
        list= [
            {
                "truckid": "556",
                "businessid": "tgjffwl",
                "corpid": "25",
                "corpname": "货满满",
                "userid": "307142",
                "username": "177****2689",
                "licenseplatenumber": "湘K00068D",
                "truckowner": "涟源瑞麟智慧物流有限公司",
                "identifycode": "LFXAH76W5R3002713",
                "licensemainimage": "tgjffwl/image/2024/08/khy/89253f1e05f1e5816b83f1756a2929da.jpeg",
                "licensesideimage": "tgjffwl/image/2024/08/khy/fcd9abf1c06b01330ca308ba68fde8d2.jpeg",
                "licenseexpiredate": "",
                "licenseissuedate": "2024-04-22",
                "licenseregisterdate": "2024-04-22",
                "licenseissueorgname": "湖南省娄底市公安局交通警察支队",
                "roadtransportnumber": "431382211291",
                "roadtransportpermitno": "431382204891",
                "transportlicensemain": "tgjffwl/image/2024/08/khy/3e6513706a411d361e441dd93f5a3acd.jpeg",
                "transportlicenseside": "",
                "transportvalidenddate": "2027-04-25",
                "trucktypecode": "Q11",
                "platecolor": "5",
                "energytype": "C",
                "registerdate": "2024-06-03",
                "inspectionenddate": "2025-04-30",
                "usenature": "货运",
                "loadweight": "38470",
                "loadlength": "0.00",
                "totalweight": "48870",
                "curbweight": "10400",
                "outlinelength": "7115",
                "outlinewidth": "2545",
                "outlineheight": "3150",
                "trailerplatenumber": "湘KB976挂",
                "trailertypecode": "B16",
                "trailerloadweight": "0",
                "businessholdsname": "涟源瑞麟智慧物流有限公司",
                "carwithownerimage": "tgjffwl/image/2024/08/khy/a5f52e16094ccd0d96f1f12486137a02.jpg",
                "truckaxles": "",
                "truckstatus": "1",
                "syncstatus": "1",
                "auditstatus": "2",
                "auditmsg": null,
                "audittime": "1724832007",
                "dateline": "1714033732",
                "modifytime": "1725603327",
                "operateuid": "307142",
                "operateuname": "17775702689",
                "thingid": "843",
                "thingname": "三一",
                "thingtype": "1",
                "thingbrand": null,
                "thingteamid": "5",
                "thingteam": "聂崎嵘",
                "placeid": "0",
                "placename": "",
                "thingbelongto": "涟源瑞麟智慧物流有限公司",
                "thingboxtype": "",
                "thingseqcode": "",
                "thingregcode": "湘K00068D",
                "thingregnum": "00068",
                "thingpower": "2",
                "thingcat": "重型半挂牵引车",
                "vehiclecode": "41619674915",
                "outcardno": "",
                "thingvin": "LFXAH76W5R3002713",
                "trailercode": null,
                "thington": "38.470",
                "thingimage": null,
                "thingregdate": "",
                "maplat": 28.192205,
                "maplng": 112.366987,
                "mapaddr": null,
                "staffname": "周解斌",
                "staffmobile": "17775702689",
                "taskid": "22045",
                "tasknum": "226",
                "leavestatus": "0",
                "thingstatus": "18",
                "applystatus": "0",
                "operatemsg": "已装货发车", 
                "vehiclelng": "112.581418",
                "vehiclelat": "25.258231",
                "vehicleheight": "70",
                "vehiclespeed": "27.00",
                "vehicledirection": "51",
                "vehiclemileage": "32764.9",
                "vehiclewarn": "0",
                "vehicleduration": "0.0",
                "vehicledate": "20240906153244",
                "todaymileage": "222.1",
                "vehicleonline": "1"
            },
            {
                "truckid": "343",
                "businessid": "tgjffwl",
                "corpid": "25",
                "corpname": "货满满",
                "userid": "299370",
                "username": "龚奇峰",
                "licenseplatenumber": "湘K00338D",
                "truckowner": "涟源瑞麟智慧物流有限公司",
                "identifycode": "LFCAH96W4N3002788",
                "licensemainimage": "tgjffwl/image/2024/08/khy/cc8f37234e000cb24ef0e8546b800d2d.jpg",
                "licensesideimage": "",
                "licenseexpiredate": "1970-01-01",
                "licenseissuedate": "2022-12-22",
                "licenseregisterdate": "2022-12-22",
                "licenseissueorgname": "湖南省娄底市公安局交通警察支队",
                "roadtransportnumber": "431382209654",
                "roadtransportpermitno": "431382204891",
                "transportlicensemain": "tgjffwl/image/2024/08/khy/7a871925fbf7015c0b083f8e73ca02e6.jpg",
                "transportlicenseside": "",
                "transportvalidenddate": "2026-03-27",
                "trucktypecode": "Q11",
                "platecolor": "5",
                "energytype": "C",
                "registerdate": "2022-12-22",
                "inspectionenddate": "",
                "usenature": "货运",
                "loadweight": "37170",
                "loadlength": "0.00",
                "totalweight": "48870",
                "curbweight": "0",
                "outlinelength": "7345",
                "outlinewidth": "2545",
                "outlineheight": "3715",
                "trailerplatenumber": "湘KV509挂",
                "trailertypecode": "B16",
                "trailerloadweight": "0",
                "businessholdsname": "涟源瑞麟智慧物流有限公司",
                "carwithownerimage": "None",
                "truckaxles": "None",
                "truckstatus": "1",
                "syncstatus": "1",
                "auditstatus": "2",
                "auditmsg": null,
                "audittime": "1724747656",
                "dateline": "1678693585",
                "modifytime": "1725537511",
                "operateuid": "299370",
                "operateuname": "198****7222",
                "thingid": "343",
                "thingname": "三一",
                "thingtype": "1",
                "thingbrand": null,
                "thingteamid": "3",
                "thingteam": "萧建春",
                "placeid": "0",
                "placename": "",
                "thingbelongto": "涟源瑞麟智慧物流有限公司",
                "thingboxtype": "",
                "thingseqcode": "",
                "thingregcode": "湘K00338D",
                "thingregnum": "00338",
                "thingpower": "2",
                "thingcat": "重型半挂牵引车",
                "vehiclecode": "64846237044",
                "outcardno": "0000003496038298",
                "thingvin": "LFCAH96W4N3002788",
                "trailercode": null,
                "thington": "37.170",
                "thingimage": null,
                "thingregdate": "",
                "maplat": 27.70461,
                "maplng": 111.862102,
                "mapaddr": null,
                "staffname": "龚奇峰",
                "staffmobile": "19873827222",
                "taskid": "0",
                "tasknum": "231",
                "leavestatus": "0",
                "thingstatus": "5",
                "applystatus": "0",
                "operatemsg": "货运司机已完工",
                "vehiclelng": "112.611415 ",
                "vehiclelat": "25.258231",
                "vehicleheight": "170",
                "vehiclespeed": "0.00",
                "vehicledirection": "0",
                "vehiclemileage": "97288.7",
                "vehiclewarn": "0",
                "vehicleduration": "0.0",
                "vehicledate": "20240906152535",
                "todaymileage": "41.9",
                "vehicleonline": "0"
            },
            {
                "truckid": "344",
                "businessid": "tgjffwl",
                "corpid": "25",
                "corpname": "货满满",
                "userid": "299368",
                "username": "180****2772",
                "licenseplatenumber": "湘K00608D",
                "truckowner": "涟源瑞麟智慧物流有限公司",
                "identifycode": "LFCAH96W0N3003582",
                "licensemainimage": "tgjffwl/image/2024/08/khy/e82d4035052a847b7c27275c3a87e8f5.png",
                "licensesideimage": "",
                "licenseexpiredate": "1970-01-01",
                "licenseissuedate": "2022-12-21",
                "licenseregisterdate": "2022-12-21",
                "licenseissueorgname": "湖南省娄底市公安局交通警察支队",
                "roadtransportnumber": "431382209718",
                "roadtransportpermitno": "431382204891",
                "transportlicensemain": "tgjffwl/image/2024/08/khy/9d1a19f0267b31846a1f310fcf98c23a.jpg",
                "transportlicenseside": "",
                "transportvalidenddate": "2026-04-02",
                "trucktypecode": "Q11",
                "platecolor": "5",
                "energytype": "C",
                "registerdate": "2022-12-21",
                "inspectionenddate": "2024-12-31",
                "usenature": "货运",
                "loadweight": "37170",
                "loadlength": "0.00",
                "totalweight": "48870",
                "curbweight": "11700",
                "outlinelength": "7345",
                "outlinewidth": "2545",
                "outlineheight": "3715",
                "trailerplatenumber": "湘KD826挂",
                "trailertypecode": "B16",
                "trailerloadweight": "0",
                "businessholdsname": "涟源瑞麟智慧物流有限公司",
                "carwithownerimage": "tgjffwl/image/2024/08/khy/48ea7e06c4fb3543f10e292a72df8096.jpg",
                "truckaxles": "None",
                "truckstatus": "1",
                "syncstatus": "1",
                "auditstatus": "2",
                "auditmsg": null,
                "audittime": "1724747656",
                "dateline": "1678693585",
                "modifytime": "1725545759",
                "operateuid": "299368",
                "operateuname": "180****2772",
                "thingid": "344",
                "thingname": "三一",
                "thingtype": "1",
                "thingbrand": null,
                "thingteamid": "3",
                "thingteam": "萧建春",
                "placeid": "0",
                "placename": "",
                "thingbelongto": "涟源瑞麟智慧物流有限公司",
                "thingboxtype": "",
                "thingseqcode": "",
                "thingregcode": "湘K00608D",
                "thingregnum": "00608",
                "thingpower": "2",
                "thingcat": "重型半挂牵引车",
                "vehiclecode": "64846210336",
                "outcardno": "0000002152393625",
                "thingvin": "LFCAH96W0N3003582",
                "trailercode": null,
                "thington": "37.170",
                "thingimage": null,
                "thingregdate": "",
                "maplat": 28.110487,
                "maplng": 111.735737,
                "mapaddr": null,
                "staffname": "周雄",
                "staffmobile": "18073862772",
                "taskid": "0",
                "tasknum": "229",
                "leavestatus": "0",
                "thingstatus": "5",
                "applystatus": "0",
                "operatemsg": "货运司机已完工",
                "vehiclelng": "112.621415",
                "vehiclelat": "25.258231",
                "vehicleheight": "213",
                "vehiclespeed": "46.50",
                "vehicledirection": "306",
                "vehiclemileage": "181669.1",
                "vehiclewarn": "0",
                "vehicleduration": "0.0",
                "vehicledate": "20240906153239",
                "todaymileage": "263.8",
                "vehicleonline": "1"
            },
            {
                "truckid": "641",
                "businessid": "tgjffwl",
                "corpid": "25",
                "corpname": "货满满",
                "userid": "306054",
                "username": "19908422633",
                "licenseplatenumber": "湘K01279D",
                "truckowner": "涟源瑞麟智慧物流有限公司",
                "identifycode": "LFXAH76W6R3002185",
                "licensemainimage": "tgjffwl/image/2024/08/khy/a3a0276ade8cc41b271e18fe670b529e.jpg",
                "licensesideimage": "tgjffwl/image/2024/08/khy/aa705497994887d787c9017af069f159.jpg",
                "licenseexpiredate": "2039-04-02",
                "licenseissuedate": "2024-04-02",
                "licenseregisterdate": "2024-04-02",
                "licenseissueorgname": "湖南省娄底市公安局交通警察支队",
                "roadtransportnumber": "431382211091",
                "roadtransportpermitno": "431382204891",
                "transportlicensemain": "tgjffwl/image/2024/08/khy/80c8de83276060a1bac63f97ac5a3be7.jpg",
                "transportlicenseside": "tgjffwl/image/2024/08/khy/94b1f6c36ecff4f5c1cca252b7ffbd5e.jpg",
                "transportvalidenddate": "2027-04-08",
                "trucktypecode": "Q11",
                "platecolor": "5",
                "energytype": "C",
                "registerdate": "2024-06-03",
                "inspectionenddate": "2025-04-30",
                "usenature": "货运",
                "loadweight": "38470",
                "loadlength": "11.00",
                "totalweight": "48870",
                "curbweight": "10400",
                "outlinelength": "7115",
                "outlinewidth": "2545",
                "outlineheight": "3150",
                "trailerplatenumber": "湘KL667挂",
                "trailertypecode": "B3E",
                "trailerloadweight": "40000",
                "businessholdsname": "涟源瑞麟智慧物流有限公司",
                "carwithownerimage": "tgjffwl/image/2024/08/khy/c99a4e5309aded8c87fa5920667c34fb.jpg",
                "truckaxles": "6轴",
                "truckstatus": "1",
                "syncstatus": "1",
                "auditstatus": "2",
                "auditmsg": null,
                "audittime": "1724838081",
                "dateline": "1713764524",
                "modifytime": "1725583174",
                "operateuid": "306054",
                "operateuname": "19908422633",
                "thingid": "740",
                "thingname": "三一",
                "thingtype": "1",
                "thingbrand": null,
                "thingteamid": "3",
                "thingteam": "萧建春",
                "placeid": "0",
                "placename": "",
                "thingbelongto": "涟源瑞麟智慧物流有限公司",
                "thingboxtype": "",
                "thingseqcode": "",
                "thingregcode": "湘K01279D",
                "thingregnum": "01279",
                "thingpower": "2",
                "thingcat": "重型半挂牵引车",
                "vehiclecode": "42055906971",
                "outcardno": "",
                "thingvin": "LFXAH76W6R3002185",
                "trailercode": null,
                "thington": "38.470",
                "thingimage": null,
                "thingregdate": "",
                "maplat": 27.776188,
                "maplng": 111.696185,
                "mapaddr": null,
                "staffname": "周玉红",
                "staffmobile": "19908422633",
                "taskid": "0",
                "tasknum": "234",
                "leavestatus": "0",
                "thingstatus": "5",
                "applystatus": "0",
                "operatemsg": "货运司机已完工",
                "vehiclelng": "112.571415",
                "vehiclelat": "25.258231",
                "vehicleheight": "173",
                "vehiclespeed": "0.00",
                "vehicledirection": "115",
                "vehiclemileage": "45770.7",
                "vehiclewarn": "0",
                "vehicleduration": "0.0",
                "vehicledate": "20240906153234",
                "todaymileage": "354.4",
                "vehicleonline": "1"
            },
            {
                "truckid": "717",
                "businessid": "tgjffwl",
                "corpid": "25",
                "corpname": "货满满",
                "userid": "306883",
                "username": "186****6399",
                "licenseplatenumber": "湘K01306D",
                "truckowner": "涟源瑞麟智慧物流有货公司",
                "identifycode": "LFXAH76W5R3002565",
                "licensemainimage": "tgjffwl/image/2024/08/khy/145800698382c9a690d9bb550e5a5a37.jpg",
                "licensesideimage": "tgjffwl/image/2024/08/khy/df9b38ce4a0422e16fa6d7c4bba4e981.jpg",
                "licenseexpiredate": "",
                "licenseissuedate": "2024-05-22",
                "licenseregisterdate": "2024-05-22",
                "licenseissueorgname": "湖南省娄底市公安局交通警察支队",
                "roadtransportnumber": "431382211476",
                "roadtransportpermitno": "431382204891",
                "transportlicensemain": "tgjffwl/image/2024/08/khy/61ddff5e4e9209cbc1b5933c66ff1329.jpg",
                "transportlicenseside": "tgjffwl/image/2024/08/khy/e69431367814da8d7f9185da7e492299.jpg",
                "transportvalidenddate": "2027-05-26",
                "trucktypecode": "Q11",
                "platecolor": "5",
                "energytype": "C",
                "registerdate": null,
                "inspectionenddate": "2025-05-31",
                "usenature": "货运",
                "loadweight": "38470",
                "loadlength": "0.00",
                "totalweight": "48870",
                "curbweight": "10400",
                "outlinelength": "7115",
                "outlinewidth": "2545",
                "outlineheight": "3150",
                "trailerplatenumber": "湘KF016挂",
                "trailertypecode": "B16",
                "trailerloadweight": "0",
                "businessholdsname": "涟源瑞麟智慧物流有货公司",
                "carwithownerimage": "tgjffwl/image/2024/08/khy/bf73f42a307d1c7c3d2aeeba52bd2aec.jpg",
                "truckaxles": "",
                "truckstatus": "1",
                "syncstatus": "1",
                "auditstatus": "2",
                "auditmsg": null,
                "audittime": "1724838968",
                "dateline": "1716969528",
                "modifytime": "1725525085",
                "operateuid": "306883",
                "operateuname": "186****6399",
                "thingid": "885",
                "thingname": "三一",
                "thingtype": "1",
                "thingbrand": null,
                "thingteamid": "10",
                "thingteam": "七星",
                "placeid": "0",
                "placename": "",
                "thingbelongto": "涟源瑞麟智慧物流有货公司",
                "thingboxtype": "",
                "thingseqcode": "",
                "thingregcode": "湘K01306D",
                "thingregnum": "01306",
                "thingpower": "2",
                "thingcat": "重型半挂牵引车",
                "vehiclecode": "42055906987",
                "outcardno": "",
                "thingvin": "LFXAH76W5R3002565",
                "trailercode": null,
                "thington": "38.470",
                "thingimage": null,
                "thingregdate": "",
                "maplat": 27.761556,
                "maplng": 111.980865,
                "mapaddr": null,
                "staffname": "曾再生",
                "staffmobile": "18673856399",
                "taskid": "0",
                "tasknum": "225",
                "leavestatus": "0",
                "thingstatus": "20",
                "applystatus": "0",
                "operatemsg": "已到达完成卸货",
                "vehiclelng": "112.661415",
                "vehiclelat": "25.254231",
                "vehicleheight": "113",
                "vehiclespeed": "0.00",
                "vehicledirection": "92",
                "vehiclemileage": "25520.4",
                "vehiclewarn": "262144",
                "vehicleduration": "0.0",
                "vehicledate": "20240906153235",
                "todaymileage": "471.6",
                "vehicleonline": "1"
            },
            {
                "truckid": "575",
                "businessid": "tgjffwl",
                "corpid": "25",
                "corpname": "货满满",
                "userid": "307074",
                "username": "183****2168",
                "licenseplatenumber": "湘K01516D",
                "truckowner": "涟源瑞麟智慧物流有限公司",
                "identifycode": "LFXAH76W0R3002683",
                "licensemainimage": "tgjffwl/image/2024/07/khy/af6e71b089ccea663991c045b2a44a94.jpg",
                "licensesideimage": "undefined",
                "licenseexpiredate": "2039-04-18",
                "licenseissuedate": "2024-04-18",
                "licenseregisterdate": "2024-04-18",
                "licenseissueorgname": "湖南省娄底市公安局交通警察大队",
                "roadtransportnumber": "431382211235",
                "roadtransportpermitno": "431382204891",
                "transportlicensemain": "tgjffwl/image/2024/07/khy/3475540d8bf214b8f67c68e02d189eb2.jpg",
                "transportlicenseside": "undefined",
                "transportvalidenddate": "2027-04-23",
                "trucktypecode": "Q11",
                "platecolor": "5",
                "energytype": "C",
                "registerdate": "2024-06-05",
                "inspectionenddate": "2025-04-30",
                "usenature": "货运",
                "loadweight": "38470",
                "loadlength": "0.00",
                "totalweight": "48870",
                "curbweight": "10400",
                "outlinelength": "7115",
                "outlinewidth": "2545",
                "outlineheight": "3150",
                "trailerplatenumber": "湘KF139挂",
                "trailertypecode": "B16",
                "trailerloadweight": "0",
                "businessholdsname": "涟源瑞麟智慧物流有限公司",
                "carwithownerimage": "tgjffwl/image/2024/08/khy/f9c5880738b445bbc10764a747129bf3.jpg",
                "truckaxles": "",
                "truckstatus": "1",
                "syncstatus": "1",
                "auditstatus": "2",
                "auditmsg": null,
                "audittime": "1724839016",
                "dateline": "1713764524",
                "modifytime": "1725590211",
                "operateuid": "307074",
                "operateuname": "183****2168",
                "thingid": "780",
                "thingname": "三一",
                "thingtype": "1",
                "thingbrand": null,
                "thingteamid": "5",
                "thingteam": "聂崎嵘",
                "placeid": "0",
                "placename": "",
                "thingbelongto": "涟源瑞麟智慧物流有限公司",
                "thingboxtype": "",
                "thingseqcode": "",
                "thingregcode": "湘K01516D",
                "thingregnum": "01516",
                "thingpower": "2",
                "thingcat": "重型半挂牵引车",
                "vehiclecode": "41619674931",
                "outcardno": "",
                "thingvin": "LFXAH76W0R3002683",
                "trailercode": null,
                "thington": "38.470",
                "thingimage": null,
                "thingregdate": "",
                "maplat": 27.942303,
                "maplng": 112.890277,
                "mapaddr": null,
                "staffname": "梁伟文",
                "staffmobile": "18373802168",
                "taskid": "22037",
                "tasknum": "231",
                "leavestatus": "0",
                "thingstatus": "18",
                "applystatus": "0",
                "operatemsg": "已装货è½¦",
                "vehiclelng": "112.601415",
                "vehiclelat": "25.268231",
                "vehicleheight": "78",
                "vehiclespeed": "0.00",
                "vehicledirection": "252",
                "vehiclemileage": "26185.7",
                "vehiclewarn": "0",
                "vehicleduration": "0.0",
                "vehicledate": "20240906153242",
                "todaymileage": "199.5",
                "vehicleonline": "1"
            },
            {
                "truckid": "345",
                "businessid": "tgjffwl",
                "corpid": "25",
                "corpname": "è´§æ»¡æ»¡",
                "userid": "305691",
                "username": "19373871777",
                "licenseplatenumber": "æ¹K01626D",
                "truckowner": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
                "identifycode": "LFCAH96W1N3003493",
                "licensemainimage": "tgjffwl/image/2024/08/khy/2a934007ee0033384bcbafe98d019c0a.png",
                "licensesideimage": "undefined",
                "licenseexpiredate": "1970-01-01",
                "licenseissuedate": "2022-12-30",
                "licenseregisterdate": "2022-12-30",
                "licenseissueorgname": "æ¹åçå¨åºå¸å¬å®å±äº¤éè­¦å¯æ¯é",
                "roadtransportnumber": "431382209721",
                "roadtransportpermitno": "431382204891",
                "transportlicensemain": "tgjffwl/image/2024/08/khy/d376430b7058c2d1276a7e14665dc0a5.jpg",
                "transportlicenseside": "undefined",
                "transportvalidenddate": "2026-04-02",
                "trucktypecode": "Q11",
                "platecolor": "5",
                "energytype": "C",
                "registerdate": "2022-12-30",
                "inspectionenddate": "",
                "usenature": "è´§è¿",
                "loadweight": "37170",
                "loadlength": "0.00",
                "totalweight": "48870",
                "curbweight": "0",
                "outlinelength": "7345",
                "outlinewidth": "2545",
                "outlineheight": "3715",
                "trailerplatenumber": "æ¹KK313æ",
                "trailertypecode": "",
                "trailerloadweight": "0",
                "businessholdsname": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
                "carwithownerimage": "None",
                "truckaxles": "",
                "truckstatus": "1",
                "syncstatus": "1",
                "auditstatus": "2",
                "auditmsg": null,
                "audittime": "1724747635",
                "dateline": "1678693585",
                "modifytime": "1725590181",
                "operateuid": "305691",
                "operateuname": "19373871777",
                "thingid": "345",
                "thingname": "ä¸ä¸",
                "thingtype": "1",
                "thingbrand": null,
                "thingteamid": "3",
                "thingteam": "è§å»ºæ¥",
                "placeid": "0",
                "placename": "",
                "thingbelongto": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
                "thingboxtype": "",
                "thingseqcode": "",
                "thingregcode": "æ¹K01626D",
                "thingregnum": "01626",
                "thingpower": "2",
                "thingcat": "éååæçµå¼è½¦",
                "vehiclecode": "64821210109",
                "outcardno": "00000010853449",
                "thingvin": "LFCAH96W1N3003493",
                "trailercode": null,
                "thington": "37.170",
                "thingimage": null,
                "thingregdate": "",
                "maplat": 27.759257,
                "maplng": 112.1623,
                "mapaddr": null,
                "staffname": "19373871777",
                "staffmobile": "19373871777",
                "taskid": "0",
                "tasknum": "235",
                "leavestatus": "0",
                "thingstatus": "5",
                "applystatus": "0",
                "operatemsg": "è´§è¿å¸æºå·²å®å·¥",
                "vehiclelng": "112.601415",
                "vehiclelat": "25.268231",
                "vehicleheight": "102",
                "vehiclespeed": "57.70",
                "vehicledirection": "81",
                "vehiclemileage": "163533.9",
                "vehiclewarn": "0",
                "vehicleduration": "0.0",
                "vehicledate": "20240906153215",
                "todaymileage": "287.2",
                "vehicleonline": "1"
            },
            {
                "truckid": "346",
                "businessid": "tgjffwl",
                "corpid": "25",
                "corpname": "è´§æ»¡æ»¡",
                "userid": "301391",
                "username": "æ·¡æ·¡çå¾®ç¬",
                "licenseplatenumber": "æ¹K01758D",
                "truckowner": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
                "identifycode": "LFCAH96W5N3003562",
                "licensemainimage": "tgjffwl/image/2024/08/khy/3bbada48e6cb63da5601ae29551baf6a.png",
                "licensesideimage": "tgjffwl/image/2024/08/khy/9c459edd2b92d7c729d76cab74350c9f.jpg",
                "licenseexpiredate": "2037-12-22",
                "licenseissuedate": "2022-12-22",
                "licenseregisterdate": "2022-12-22",
                "licenseissueorgname": "æ¹åçå¨åºå¸å¬å®å±äº¤éè­¦å¯æ¯é",
                "roadtransportnumber": "431382209666",
                "roadtransportpermitno": "431382204891",
                "transportlicensemain": "tgjffwl/image/2024/08/khy/254e839e4cae78ad630e2bd3c59a23a3.jpg",
                "transportlicenseside": "tgjffwl/image/2024/08/khy/50132c87ea70ce14b8dff96dfa4c06e5.jpg",
                "transportvalidenddate": "2026-03-28",
                "trucktypecode": "Q11",
                "platecolor": "5",
                "energytype": "C",
                "registerdate": "2022-12-22",
                "inspectionenddate": "",
                "usenature": "è´§è¿",
                "loadweight": "37170",
                "loadlength": "0.00",
                "totalweight": "48870",
                "curbweight": "0",
                "outlinelength": "7345",
                "outlinewidth": "2545",
                "outlineheight": "3715",
                "trailerplatenumber": "æ¹KH185æ",
                "trailertypecode": "B16",
                "trailerloadweight": "0",
                "businessholdsname": "æ¶æºçéºæºæ§ç©æµæéå¬å¸",
                "carwithownerimage": "None",
                "truckaxles": "None",
                "truckstatus": "1",
                "syncstatus": "1",
                "auditstatus": "2",
                "auditmsg": null,
                "audittime": "1724815729",
                "dateline": "1678693585",
                "modifytime": "1725597556",
                "operateuid": "301391",
                "operateuname": "淡淡的微笑",
                "thingid": "346",
                "thingname": "三一",
                "thingtype": "1",
                "thingbrand": null,
                "thingteamid": "3",
                "thingteam": "萧建春",
                "placeid": "0",
                "placename": "",
                "thingbelongto": "涟源瑞麟智慧物流有限公司",
                "thingboxtype": "",
                "thingseqcode": "",
                "thingregcode": "湘K01758D",
                "thingregnum": "01758",
                "thingpower": "2",
                "thingcat": "重型半挂牵引车",
                "vehiclecode": "64846237171",
                "outcardno": "",
                "thingvin": "LFCAH96W5N3003562",
                "trailercode": null,
                "thington": "37.170",
                "thingimage": null,
                "thingregdate": "",
                "maplat": 28.055675,
                "maplng": 112.910072,
                "mapaddr": null,
                "staffname": "吴孟均",
                "staffmobile": "17573885598",
                "taskid": "22054",
                "tasknum": "226",
                "leavestatus": "0",
                "thingstatus": "18",
                "applystatus": "0",
                "operatemsg": "已装货发车",
                "vehiclelng": "112.601415",
                "vehiclelat": "25.268231",
                "vehicleheight": "36",
                "vehiclespeed": "0.00",
                "vehicledirection": "0",
                "vehiclemileage": "183935.7",
                "vehiclewarn": "0",
                "vehicleduration": "0.0",
                "vehicledate": "20240906153224",
                "todaymileage": "343.1",
                "vehicleonline": "1"
            },
            {
                "truckid": "347",
                "businessid": "tgjffwl",
                "corpid": "25",
                "corpname": "货满满",
                "userid": "300276",
                "username": "180****1916",
                "licenseplatenumber": "湘K01796D",
                "truckowner": "涟源瑞麟智慧物流有限公司",
                "identifycode": "LFCAH96W4N3003553",
                "licensemainimage": "tgjffwl/image/2024/08/khy/f3afc31ee366ca238651d05905bb53b3.png",
                "licensesideimage": "tgjffwl/image/2024/08/khy/24c26d1820ca376e1fb5290b9d85dadb.jpg",
                "licenseexpiredate": "1970-01-01",
                "licenseissuedate": "2022-12-21",
                "licenseregisterdate": "2022-12-21",
                "licenseissueorgname": "湖南省娄底市公安局交通警察支队",
                "roadtransportnumber": "431382209646",
                "roadtransportpermitno": "431382204891",
                "transportlicensemain": "tgjffwl/image/2024/08/khy/2b31bd68b7d750c7a06b20ba8e1c46e2.jpg",
                "transportlicenseside": "",
                "transportvalidenddate": "2026-03-27",
                "trucktypecode": "Q11",
                "platecolor": "5",
                "energytype": "C",
                "registerdate": "2022-12-21",
                "inspectionenddate": "",
                "usenature": "货运",
                "loadweight": "37170",
                "loadlength": "0.00",
                "totalweight": "48870",
                "curbweight": "0",
                "outlinelength": "7345",
                "outlinewidth": "2545",
                "outlineheight": "3715",
                "trailerplatenumber": "湘KU039挂",
                "trailertypecode": "B16",
                "trailerloadweight": "0",
                "businessholdsname": "涟源瑞麟智慧物流有限公司",
                "carwithownerimage": "tgjffwl/image/2024/08/khy/9cdf8f091a8be3b8c74e17505e433e19.jpg",
                "truckaxles": "None",
                "truckstatus": "1",
                "syncstatus": "1",
                "auditstatus": "2",
                "auditmsg": null,
                "audittime": "1724814499",
                "dateline": "1678693585",
                "modifytime": "1725529428",
                "operateuid": "300276",
                "operateuname": "18033081916",
                "thingid": "347",
                "thingname": "三一",
                "thingtype": "1",
                "thingbrand": null,
                "thingteamid": "3",
                "thingteam": "萧建春",
                "placeid": "0",
                "placename": "",
                "thingbelongto": "涟源瑞麟智慧物流有限公司",
                "thingboxtype": "",
                "thingseqcode": "",
                "thingregcode": "湘K01796D",
                "thingregnum": "01796",
                "thingpower": "2",
                "thingcat": "重型半挂牵引车",
                "vehiclecode": "64846807419",
                "outcardno": "",
                "thingvin": "LFCAH96W4N3003553",
                "trailercode": null,
                "thington": "37.170",
                "thingimage": null,
                "thingregdate": "",
                "maplat": 27.70465,
                "maplng": 111.862255,
                "mapaddr": null,
                "staffname": "张新铭",
                "staffmobile": "18033081916",
                "taskid": "0",
                "tasknum": "222",
                "leavestatus": "0",
                "thingstatus": "5",
                "applystatus": "0",
                "operatemsg": "货运司机已完工",
                "vehiclelng": "112.601415",
                "vehiclelat": "25.268231",
                "vehicleheight": "137",
                "vehiclespeed": "0.00",
                "vehicledirection": "0",
                "vehiclemileage": "157072.2",
                "vehiclewarn": "256",
                "vehicleduration": "0.0",
                "vehicledate": "20240906110635",
                "todaymileage": "156.4",
                "vehicleonline": "0"
            },
            {
                "truckid": "439",
                "businessid": "tgjffwl",
                "corpid": "25",
                "corpname": "货满满",
                "userid": "307083",
                "username": "易建成",
                "licenseplatenumber": "湘K01889D",
                "truckowner": "涟源瑞麟智慧物流有限公司",
                "identifycode": "LFCAH96W0N3003551",
                "licensemainimage": "tgjffwl/image/2024/08/khy/a7d801cf1e174b668f6dc0370e9237a5.png",
                "licensesideimage": "",
                "licenseexpiredate": "1970-01-01",
                "licenseissuedate": "2022-12-21",
                "licenseregisterdate": "2022-12-21",
                "licenseissueorgname": "湖南省娄底市公安局交通警察支队",
                "roadtransportnumber": "431382209722",
                "roadtransportpermitno": "431382204891",
                "transportlicensemain": "tgjffwl/image/2024/08/khy/a0ba7319c9ca34f84b4803cc81a5422c.jpg",
                "transportlicenseside": "",
                "transportvalidenddate": "2026-04-02",
                "trucktypecode": "Q11",
                "platecolor": "5",
                "energytype": "C",
                "registerdate": "2022-12-21",
                "inspectionenddate": "",
                "usenature": "货运",
                "loadweight": "37170",
                "loadlength": "0.00",
                "totalweight": "48870",
                "curbweight": "0",
                "outlinelength": "7345",
                "outlinewidth": "2545",
                "outlineheight": "3715",
                "trailerplatenumber": "湘K9083挂",
                "trailertypecode": "B16",
                "trailerloadweight": "0",
                "businessholdsname": "涟源瑞麟智慧物流有限公司",
                "carwithownerimage": "None",
                "truckaxles": "None",
                "truckstatus": "1",
                "syncstatus": "1",
                "auditstatus": "2",
                "auditmsg": null,
                "audittime": "1724747635",
                "dateline": "1678693585",
                "modifytime": "1725591701",
                "operateuid": "307083",
                "operateuname": "134****9173",
                "thingid": "348",
                "thingname": "三一",
                "thingtype": "1",
                "thingbrand": null,
                "thingteamid": "3",
                "thingteam": "萧建春",
                "placeid": "0",
                "placename": "",
                "thingbelongto": "涟源瑞麟智慧物流有限公司",
                "thingboxtype": "",
                "thingseqcode": "",
                "thingregcode": "湘K02289D",
                "thingregnum": "01889",
                "thingpower": "2",
                "thingcat": "重型半挂牵引车",
                "vehiclecode": "64846214914",
                "outcardno": "",
                "thingvin": "LFCAH96W0N3003551",
                "trailercode": null,
                "thington": "37.170",
                "thingimage": null,
                "thingregdate": "",
                "maplat": 27.763667,
                "maplng": 112.521259,
                "mapaddr": null,
                "staffname": "易建成",
                "staffmobile": "13467889173",
                "taskid": "0",
                "tasknum": "225",
                "leavestatus": "0",
                "thingstatus": "5",
                "applystatus": "0",
                "operatemsg": "货运司机已完工",
                "vehiclelng": "112.601415",
                "vehiclelat": "25.268231",
                "vehicleheight": "51",
                "vehiclespeed": "59.40",
                "vehicledirection": "70",
                "vehiclemileage": "140629.3",
                "vehiclewarn": "0",
                "vehicleduration": "0.0",
                "vehicledate": "20240906153228",
                "todaymileage": "244.7",
                "vehicleonline": "1"
            }
       ]
        
    }else if(obj=='total'){
        data={
            "today": {
                "taskcnt": "211",
                "thingcnt": "323",
                "plancnt": "87",
                "doingcnt": "23",
                "finishcnt": "54",
                "startweightsum": "3520.52",
                "finishweightsum": "3337.53",
                "feerepair": "0.00",
                "feeother": "0.00",
                "feesalary": "0.00",
                "billmoney": "12359.04"
            },
            "month": {
                "taskcnt": "1821",
                "thingcnt": "153",
                "plancnt": "2128",
                "doingcnt": "39",
                "finishcnt": "1092",
                "startweightsum": "60264.23",
                "finishweightsum": "38558.83",
                "feerepair": "0.00",
                "feeother": "246.11",
                "feesalary": "0.00",
                "billmoney": "153513.52"
            },
            "total": {
                "taskcnt": "25399",
                "thingcnt": "161",
                "plancnt": "25399",
                "doingcnt": "47",
                "finishcnt": "25352",
                "startweightsum": "827267.33",
                "finishweightsum": "817840.94",
                "feerepair": "0.00",
                "feeother": "4720.65",
                "feesalary": "0.00",
                "billmoney": "3423965.47"
            }
        }	
        
    }else if(obj=='taskfromid'){
        list= 
            [
                {
                    "totaltask": "37",
                    "totalstartweight": "1063.79",
                    "totalfinishweight": "1072.63",
                    "totalbillmoney": "2960.00",
                    "groupid": "26",
                    "taskfromid": "26",
                    "taskfromaddr": null,
                    "placeid": "26",
                    "placetype": "1",
                    "placename": "湘竹",
                    "placeaddr": "湘潭市湘竹建材有限公司",
                    "placelat": "27.8944111",
                    "placelng": "112.9570694"
                },
                {
                    "totaltask": "30",
                    "totalstartweight": "972.12",
                    "totalfinishweight": "958.87",
                    "totalbillmoney": "3435.56",
                    "groupid": "16",
                    "taskfromid": "16",
                    "taskfromaddr": null,
                    "placeid": "16",
                    "placetype": "1",
                    "placename": "雷鸣",
                    "placeaddr": "涟源市雷鸣釆石场",
                    "placelat": "27.9675240",
                    "placelng": "111.9091950"
                },
                {
                    "totaltask": "16",
                    "totalstartweight": "573.48",
                    "totalfinishweight": "567.69",
                    "totalbillmoney": "4886.96",
                    "groupid": "12",
                    "taskfromid": "12",
                    "taskfromaddr": null,
                    "placeid": "12",
                    "placetype": "1",
                    "placename": "齐兴",
                    "placeaddr": "涟源市齐",
                    "placelat": "27.7769950",
                    "placelng": "111.6966750"
                },
                {
                    "totaltask": "14",
                    "totalstartweight": "482.45",
                    "totalfinishweight": "482.45",
                    "totalbillmoney": "0.00",
                    "groupid": "17",
                    "taskfromid": "17",
                    "taskfromaddr": null,
                    "placeid": "17",
                    "placetype": "1",
                    "placename": "海螺",
                    "placeaddr": "",
                    "placelat": "27.7117350",
                    "placelng": "111.9024000"
                },
            ]
        	   
    }else if(obj=='taskfromidmonth'){
        
        list=[
            {
            			"totaltask": "354",
            			"totalstartweight": "11836.40",
            			"totalfinishweight": "11598.83",
            			"totalbillmoney": "42117.03",
            			"groupid": "16",
            			"taskfromid": "16",
            			"taskfromaddr": null,
            			"placeid": "16",
            			"placetype": "1",
            			"placename": "雷鸣",
            			"placeaddr": "涟源市雷鸣釆石场",
            			"placelat": "27.9675240",
            			"placelng": "111.9091950"
            		},
            		{
            			"totaltask": "241",
            			"totalstartweight": "7043.63",
            			"totalfinishweight": "7003.65",
            			"totalbillmoney": "19185.40",
            			"groupid": "26",
            			"taskfromid": "26",
            			"taskfromaddr": null,
            			"placeid": "26",
            			"placetype": "1",
            			"placename": "湘竹",
            			"placeaddr": "湘潭市湘竹建材有限公司",
            			"placelat": "27.8944111",
            			"placelng": "112.9570694"
            		},
            		{
            			"totaltask": "147",
            			"totalstartweight": "5159.29",
            			"totalfinishweight": "5127.96",
            			"totalbillmoney": "32415.12",
            			"groupid": "12",
            			"taskfromid": "12",
            			"taskfromaddr": null,
            			"placeid": "12",
            			"placetype": "1",
            			"placename": "齐兴",
            			"placeaddr": "涟源市齐兴石业有限公司",
            			"placelat": "27.7769950",
            			"placelng": "111.6966750"
            		},
            		{
            			"totaltask": "159",
            			"totalstartweight": "4956.42",
            			"totalfinishweight": "4908.66",
            			"totalbillmoney": "0.00",
            			"groupid": "39",
            			"taskfromid": "39",
            			"taskfromaddr": null,
            			"placeid": "39",
            			"placetype": "1",
            			"placename": "金铃",
            			"placeaddr": "湖南金铃建材有限公司",
            			"placelat": "27.7237830",
            			"placelng": "111.9027250"
            		},
            		{
            			"totaltask": "137",
            			"totalstartweight": "4644.96",
            			"totalfinishweight": "4649.44",
            			"totalbillmoney": "0.00",
            			"groupid": "790",
            			"taskfromid": "790",
            			"taskfromaddr": null,
            			"placeid": "790",
            			"placetype": "1",
            			"placename": "大山冲",
            			"placeaddr": "水洞底镇大山冲采石场",
            			"placelat": "27.6877800",
            			"placelng": "111.9272500"
            		},
            		{
            			"totaltask": "137",
            			"totalstartweight": "4484.14",
            			"totalfinishweight": "4485.96",
            			"totalbillmoney": "26339.15",
            			"groupid": "25",
            			"taskfromid": "25",
            			"taskfromaddr": null,
            			"placeid": "25",
            			"placetype": "1",
            			"placename": "海螺",
            			"placeaddr": "涟源海螺水泥有限公司",
            			"placelat": "27.6673069",
            			"placelng": "111.8681564"
            		},
            		{
            			"totaltask": "99",
            			"totalstartweight": "3451.93",
            			"totalfinishweight": "3482.02",
            			"totalbillmoney": "21882.12",
            			"groupid": "53",
            			"taskfromid": "53",
            			"taskfromaddr": null,
            			"placeid": "53",
            			"placetype": "1",
            			"placename": "雍和码头",
            			"placeaddr": "湖南雍和物流有限公司",
            			"placelat": "27.7920020",
            			"placelng": "112.8980500"
            		},
        ]
    }else if(obj=='group'){
        list=[
            {
            			"totaltask": "190",
            			"totalstartweight": "6513.34",
            			"totalfinishweight": "6540.79",
            			"totalbillmoney": "0.00",
            			"groupid": "98",
            			"taskfromid": "98",
            			"taskfromaddr": null,
            			"placeid": "98",
            			"placetype": "1",
            			"placename": "黄谷路",
            			"placeaddr": "鄱阳佳郡",
            			"placelat": "28.0794240",
            			"placelng": "113.0158300"
            		},
            		{
            			"totaltask": "187",
            			"totalstartweight": "6352.80",
            			"totalfinishweight": "6351.21",
            			"totalbillmoney": "0.00",
            			"groupid": "134",
            			"taskfromid": "134",
            			"taskfromaddr": null,
            			"placeid": "134",
            			"placetype": "1",
            			"placename": "天心区新路消防救援站",
            			"placeaddr": "天心区和泓融成府南150米(万家丽南路南)",
            			"placelat": "28.0523300",
            			"placelng": "112.9818300"
            		},
            		{
            			"totaltask": "166",
            			"totalstartweight": "5843.55",
            			"totalfinishweight": "5841.59",
            			"totalbillmoney": "0.00",
            			"groupid": "106",
            			"taskfromid": "106",
            			"taskfromaddr": null,
            			"placeid": "106",
            			"placetype": "1",
            			"placename": "坪塘",
            			"placeaddr": "岳麓区汀湘十里西100米(含浦大道西)",
            			"placelat": "28.1164230",
            			"placelng": "112.8988000"
            		},
            		{
            			"totaltask": "153",
            			"totalstartweight": "5559.35",
            			"totalfinishweight": "5499.82",
            			"totalbillmoney": "0.00",
            			"groupid": "33",
            			"taskfromid": "33",
            			"taskfromaddr": "双江口加工厂",
            			"placeid": "33",
            			"placetype": "1",
            			"placename": "双江口加工厂",
            			"placeaddr": "涟源市龙塘镇上梅桥",
            			"placelat": "27.7719550",
            			"placelng": "111.7160900"
            		},
            		{
            			"totaltask": "128",
            			"totalstartweight": "4399.65",
            			"totalfinishweight": "4343.99",
            			"totalbillmoney": "0.00",
            			"groupid": "785",
            			"taskfromid": "785",
            			"taskfromaddr": null,
            			"placeid": "785",
            			"placetype": "1",
            			"placename": "临亚",
            			"placeaddr": "湖南临亚新型墙体材料有限公司",
            			"placelat": "28.3076690",
            			"placelng": "112.2171900"
            		},
            		{
            			"totaltask": "112",
            			"totalstartweight": "3926.15",
            			"totalfinishweight": "3919.45",
            			"totalbillmoney": "1183.00",
            			"groupid": "75",
            			"taskfromid": "75",
            			"taskfromaddr": null,
            			"placeid": "75",
            			"placetype": "1",
            			"placename": "荣贵",
            			"placeaddr": "涟源市斗笠山镇大石山采石场",
            			"placelat": "27.7019390",
            			"placelng": "111.8833200"
            		},
            		{
            			"totaltask": "96",
            			"totalstartweight": "3196.34",
            			"totalfinishweight": "3185.95",
            			"totalbillmoney": "0.00",
            			"groupid": "728",
            			"taskfromid": "728",
            			"taskfromaddr": null,
            			"placeid": "728",
            			"placetype": "1",
            			"placename": "梅城镇",
            			"placeaddr": "安化县仙溪镇梅城镇",
            			"placelat": "28.2077790",
            			"placelng": "111.6191900"
            		},
        ]
        
        
    }else if(obj=='station'){
 
        list=[
                // {
                //     "StationID": "3cca6d6ba23330134011637040053",
                //     "StationName": "天筑六建充电站",
                //     "StationStatus": "50",
                //     "StationLat": "28.0486400",
                //     "StationLng": "112.9707000",
                //     "Address": "湖南省长沙市天心区湖南天筑六建混凝土有限公司南",
                //     "StationType": "1",
                //     "CountryCode": "CN",
                //     "ServiceFee": "00:00~07:00,0;07:00~11:00,0;11:00~14:00,0;14:00~18:00,0;18:00~22:00,0;22:00~23:00,0;23:00~24:00,0",
                //     "ElectricityFee": "00:00~07:00,34;07:00~11:00,77;11:00~14:00,122;14:00~18:00,77;18:00~22:00,145;22:00~23:00,122;23:00~24:00,34",
                //     "Payment": "线上",
                //     "RunDate": "2024-09-06",
                //     "Construction": "127",
                //     "OperatorID": "793491805",
                //     "ServiceStaff": "",
                //     "ServiceMobile": "",
                //     "ServiceOpen": "0",
                //     "EquipmentInfos": [
                //         {
                //             "EquipmentID": "1010137040053008",
                //             "EquipmentName": "8号桩",
                //             "EquipmentType": "1",
                //             "ManufacturerID": "793491805",
                //             "ManufacturerName": "广州锐速智能科技股份有限公司",
                //             "Power": "360",
                //             "EquipmentLat": "28.049",
                //             "EquipmentLng": "112.971",
                //             "ConnectorInfos": [
                //                 {
                //                     "ConnectorID": "10370400530082",
                //                     "ConnectorName": "2",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "1"
                //                 },
                //                 {
                //                     "ConnectorID": "10370400530081",
                //                     "ConnectorName": "1",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "2"
                //                 }
                //             ]
                //         },
                //         {
                //             "EquipmentID": "1010137040053002",
                //             "EquipmentName": "2号桩",
                //             "EquipmentType": "1",
                //             "ManufacturerID": "793491805",
                //             "ManufacturerName": "广州锐速智能科技股份有限公司",
                //             "Power": "360",
                //             "EquipmentLat": "28.049",
                //             "EquipmentLng": "112.971",
                //             "ConnectorInfos": [
                //                 {
                //                     "ConnectorID": "10370400530022",
                //                     "ConnectorName": "2",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "3"
                //                 },
                //                 {
                //                     "ConnectorID": "10370400530021",
                //                     "ConnectorName": "1",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "4"
                //                 }
                //             ]
                //         },
                //         {
                //             "EquipmentID": "1010137040053003",
                //             "EquipmentName": "3号桩",
                //             "EquipmentType": "1",
                //             "ManufacturerID": "793491805",
                //             "ManufacturerName": "广州锐速智能科技股份有限公司",
                //             "Power": "360",
                //             "EquipmentLat": "28.049",
                //             "EquipmentLng": "112.971",
                //             "ConnectorInfos": [
                //                 {
                //                     "ConnectorID": "10370400530032",
                //                     "ConnectorName": "2",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "5"
                //                 },
                //                 {
                //                     "ConnectorID": "10370400530031",
                //                     "ConnectorName": "1",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "6"
                //                 }
                //             ]
                //         },
                //         {
                //             "EquipmentID": "1010137040053006",
                //             "EquipmentName": "6号桩",
                //             "EquipmentType": "1",
                //             "ManufacturerID": "793491805",
                //             "ManufacturerName": "广州锐速智能科技股份有限公司",
                //             "Power": "360",
                //             "EquipmentLat": "28.049",
                //             "EquipmentLng": "112.971",
                //             "ConnectorInfos": [
                //                 {
                //                     "ConnectorID": "10370400530062",
                //                     "ConnectorName": "2",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "7"
                //                 },
                //                 {
                //                     "ConnectorID": "10370400530061",
                //                     "ConnectorName": "1",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "8"
                //                 }
                //             ]
                //         },
                //         {
                //             "EquipmentID": "1010137040053009",
                //             "EquipmentName": "9号桩",
                //             "EquipmentType": "1",
                //             "ManufacturerID": "793491805",
                //             "ManufacturerName": "广州锐速智能科技股份有限公司",
                //             "Power": "360",
                //             "EquipmentLat": "28.049",
                //             "EquipmentLng": "112.971",
                //             "ConnectorInfos": [
                //                 {
                //                     "ConnectorID": "10370400530091",
                //                     "ConnectorName": "1",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "9"
                //                 },
                //                 {
                //                     "ConnectorID": "10370400530092",
                //                     "ConnectorName": "2",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "10"
                //                 }
                //             ]
                //         },
                //         {
                //             "EquipmentID": "1010137040053004",
                //             "EquipmentName": "4号桩",
                //             "EquipmentType": "1",
                //             "ManufacturerID": "793491805",
                //             "ManufacturerName": "广州锐速智能科技股份有限公司",
                //             "Power": "360",
                //             "EquipmentLat": "28.049",
                //             "EquipmentLng": "112.971",
                //             "ConnectorInfos": [
                //                 {
                //                     "ConnectorID": "10370400530041",
                //                     "ConnectorName": "1",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "11"
                //                 },
                //                 {
                //                     "ConnectorID": "10370400530042",
                //                     "ConnectorName": "2",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "12"
                //                 }
                //             ]
                //         },
                //         {
                //             "EquipmentID": "1010137040053007",
                //             "EquipmentName": "7号桩",
                //             "EquipmentType": "1",
                //             "ManufacturerID": "793491805",
                //             "ManufacturerName": "广州锐速智能科技股份有限公司",
                //             "Power": "360",
                //             "EquipmentLat": "28.049",
                //             "EquipmentLng": "112.971",
                //             "ConnectorInfos": [
                //                 {
                //                     "ConnectorID": "10370400530071",
                //                     "ConnectorName": "1",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "13"
                //                 },
                //                 {
                //                     "ConnectorID": "10370400530072",
                //                     "ConnectorName": "2",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "14"
                //                 }
                //             ]
                //         },
                //         {
                //             "EquipmentID": "1010137040053001",
                //             "EquipmentName": "1号桩",
                //             "EquipmentType": "1",
                //             "ManufacturerID": "793491805",
                //             "ManufacturerName": "广州锐速智能科技股份有限公司",
                //             "Power": "360",
                //             "EquipmentLat": "28.049",
                //             "EquipmentLng": "112.971",
                //             "ConnectorInfos": [
                //                 {
                //                     "ConnectorID": "10370400530012",
                //                     "ConnectorName": "2",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "15"
                //                 },
                //                 {
                //                     "ConnectorID": "10370400530011",
                //                     "ConnectorName": "1",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "16"
                //                 }
                //             ]
                //         },
                //         {
                //             "EquipmentID": "1010137040053005",
                //             "EquipmentName": "5号桩",
                //             "EquipmentType": "1",
                //             "ManufacturerID": "793491805",
                //             "ManufacturerName": "广州锐速智能科技股份有限公司",
                //             "Power": "360",
                //             "EquipmentLat": "28.049",
                //             "EquipmentLng": "112.971",
                //             "ConnectorInfos": [
                //                 {
                //                     "ConnectorID": "10370400530051",
                //                     "ConnectorName": "1",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "17"
                //                 },
                //                 {
                //                     "ConnectorID": "10370400530052",
                //                     "ConnectorName": "2",
                //                     "ConnectorType": "4",
                //                     "Status": "0",
                //                     "Current": "0",
                //                     "CurrentLowerLimits": "0",
                //                     "CurrentUpperLimits": "0",
                //                     "VoltageLowerLimits": "0",
                //                     "VoltageUpperLimits": "0",
                //                     "CID": "18"
                //                 }
                //             ]
                //         }
                //     ]
                // },
                {
                    "StationID": "9ed210ce92311271259161779702",
                    "StationName": "瑞麟物流娄底充电站",
                    "StationStatus": "50",
                    "StationLat": "27.7652020",
                    "StationLng": "111.9812550",
                    "Address": "湖南省娄底市娄星区湘安驾校内",
                    "StationType": "1",
                    "CountryCode": "CN",
                    "ServiceFee": "00:00~07:00,0;07:00~11:00,0;11:00~14:00,0;14:00~18:00,0;18:00~22:00,0;22:00~23:00,0;23:00~24:00,0",
                    "ElectricityFee": "00:00~07:00,34;07:00~11:00,77;11:00~14:00,122;14:00~18:00,77;18:00~22:00,145;22:00~23:00,122;23:00~24:00,34",
                    "Payment": "线上",
                    "RunDate": "2024-09-06",
                    "Construction": "127",
                    "OperatorID": "793491805",
                    "ServiceStaff": null,
                    "ServiceMobile": null,
                    "ServiceOpen": "0",
                    "EquipmentInfos": [
                        {
                            "EquipmentID": "1010161779702009",
                            "EquipmentName": "9号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "300",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020092",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "63"
                                },
                                {
                                    "ConnectorID": "10617797020091",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "64"
                                },
                                {
                                    "ConnectorID": "10617797020094",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "89"
                                },
                                {
                                    "ConnectorID": "10617797020093",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "90"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702005",
                            "EquipmentName": "5号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020052",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "65"
                                },
                                {
                                    "ConnectorID": "10617797020051",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "66"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702008",
                            "EquipmentName": "8号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020082",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "67"
                                },
                                {
                                    "ConnectorID": "10617797020081",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "68"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702003",
                            "EquipmentName": "3号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020031",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "69"
                                },
                                {
                                    "ConnectorID": "10617797020032",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "70"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702010",
                            "EquipmentName": "10号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "300",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020101",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "71"
                                },
                                {
                                    "ConnectorID": "10617797020102",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "72"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702007",
                            "EquipmentName": "7号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020071",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "73"
                                },
                                {
                                    "ConnectorID": "10617797020072",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "74"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702012",
                            "EquipmentName": "12号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "300",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020121",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "75"
                                },
                                {
                                    "ConnectorID": "10617797020122",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "76"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702001",
                            "EquipmentName": "1号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020011",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "77"
                                },
                                {
                                    "ConnectorID": "10617797020012",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "78"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702006",
                            "EquipmentName": "6号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020061",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "79"
                                },
                                {
                                    "ConnectorID": "10617797020062",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "80"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702002",
                            "EquipmentName": "2号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020021",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "81"
                                },
                                {
                                    "ConnectorID": "10617797020022",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "82"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702004",
                            "EquipmentName": "4号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020042",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "83"
                                },
                                {
                                    "ConnectorID": "10617797020041",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "84"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702011",
                            "EquipmentName": "11号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "300",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020111",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "85"
                                },
                                {
                                    "ConnectorID": "10617797020112",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "86"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010161779702013",
                            "EquipmentName": "223号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.765",
                            "EquipmentLng": "111.981",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10617797020131",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "1",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "87"
                                },
                                {
                                    "ConnectorID": "10617797020132",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "1",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "88"
                                }
                            ]
                        }
                    ]
                },
                {
                    "StationID": "56e1afcb52356114225525663958",
                    "StationName": "龙塘镇江口村铁底山下齐兴矿业充电站",
                    "StationStatus": "50",
                    "StationLat": "27.6168450",
                    "StationLng": "112.2900330",
                    "Address": "湖南省娄底市涟源市龙塘镇江口村铁底山下齐兴矿业",
                    "StationType": "1",
                    "CountryCode": "CN",
                    "ServiceFee": "00:00~07:00,0;07:00~11:00,0;11:00~14:00,0;14:00~18:00,0;18:00~23:00,0;23:00~24:00,0",
                    "ElectricityFee": "00:00~07:00,34;07:00~11:00,80;11:00~14:00,120;14:00~18:00,80;18:00~23:00,120;23:00~24:00,34",
                    "Payment": "线上",
                    "RunDate": "2024-09-06",
                    "Construction": "127",
                    "OperatorID": "793491805",
                    "ServiceStaff": null,
                    "ServiceMobile": null,
                    "ServiceOpen": "0",
                    "EquipmentInfos": [
                        {
                            "EquipmentID": "1010125663958003",
                            "EquipmentName": "3号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "360",
                            "EquipmentLat": "27.617",
                            "EquipmentLng": "112.290",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10256639580031",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "31",
                                    "CurrentLowerLimits": "31",
                                    "CurrentUpperLimits": "31",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "43"
                                },
                                {
                                    "ConnectorID": "10256639580032",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "44"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010125663958005",
                            "EquipmentName": "5号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "300",
                            "EquipmentLat": "27.617",
                            "EquipmentLng": "112.290",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10256639580051",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "45"
                                },
                                {
                                    "ConnectorID": "10256639580052",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "46"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010125663958002",
                            "EquipmentName": "2号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.617",
                            "EquipmentLng": "112.290",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10256639580021",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "47"
                                },
                                {
                                    "ConnectorID": "10256639580022",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "48"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010125663958004",
                            "EquipmentName": "4号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "360",
                            "EquipmentLat": "27.617",
                            "EquipmentLng": "112.290",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10256639580041",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "49"
                                },
                                {
                                    "ConnectorID": "10256639580042",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "50"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "1010125663958001",
                            "EquipmentName": "1号桩",
                            "EquipmentType": "1",
                            "ManufacturerID": "793491805",
                            "ManufacturerName": "广州锐速智能科技股份有限公司",
                            "Power": "320",
                            "EquipmentLat": "27.617",
                            "EquipmentLng": "112.290",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "10256639580012",
                                    "ConnectorName": "2",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "51"
                                },
                                {
                                    "ConnectorID": "10256639580011",
                                    "ConnectorName": "1",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "0",
                                    "VoltageUpperLimits": "0",
                                    "CID": "52"
                                }
                            ]
                        }
                    ]
                },
                {
                    "StationID": "255",
                    "StationName": "京能充电金玲建材超充站",
                    "StationStatus": "50",
                    "StationLat": "27.7785740",
                    "StationLng": "111.7015960",
                    "Address": "湖南省娄底市涟源市涟源市齐兴石业有限公司",
                    "StationType": "50",
                    "CountryCode": "CN",
                    "ServiceFee": "00:00~24:00,50",
                    "ElectricityFee": "00:00~24:00,100",
                    "Payment": "",
                    "RunDate": "2022-06-19",
                    "Construction": "127",
                    "OperatorID": "396325054",
                    "ServiceStaff": null,
                    "ServiceMobile": null,
                    "ServiceOpen": "0",
                    "EquipmentInfos": [
                        {
                            "EquipmentID": "22101295",
                            "EquipmentName": "360kw直流双枪",
                            "EquipmentType": "1",
                            "ManufacturerID": "396325054",
                            "ManufacturerName": "湖南京能新能源科技有限公司",
                            "Power": "360",
                            "EquipmentLat": "27.779",
                            "EquipmentLng": "111.702",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "2210129501",
                                    "ConnectorName": "1号枪",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "380",
                                    "VoltageUpperLimits": "750",
                                    "CID": "59"
                                },
                                {
                                    "ConnectorID": "2210129502",
                                    "ConnectorName": "2号枪",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "380",
                                    "VoltageUpperLimits": "750",
                                    "CID": "60"
                                }
                            ]
                        },
                        {
                            "EquipmentID": "22101297",
                            "EquipmentName": "360KW直流双枪",
                            "EquipmentType": "1",
                            "ManufacturerID": "396325054",
                            "ManufacturerName": "湖南京能新能源科技有限公司",
                            "Power": "360",
                            "EquipmentLat": "27.779",
                            "EquipmentLng": "111.702",
                            "ConnectorInfos": [
                                {
                                    "ConnectorID": "2210129701",
                                    "ConnectorName": "1号枪",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "380",
                                    "VoltageUpperLimits": "750",
                                    "CID": "61"
                                },
                                {
                                    "ConnectorID": "2210129702",
                                    "ConnectorName": "2号枪",
                                    "ConnectorType": "4",
                                    "Status": "0",
                                    "Current": "0",
                                    "CurrentLowerLimits": "0",
                                    "CurrentUpperLimits": "0",
                                    "VoltageLowerLimits": "380",
                                    "VoltageUpperLimits": "750",
                                    "CID": "62"
                                }
                            ]
                        }
                    ]
                },
                
        ]
            
    }else if(obj=="month"){
        data= {
        	"month6": [
        		{
        			"taskmonth": "2024-03",
        			"taskcnt": "370",
        			"thingcnt": "8",
        			"plancnt": "370",
        			"doingcnt": "0",
        			"finishcnt": "370",
        			"startweightsum": "12361.95",
        			"finishweightsum": "52250.35",
        			"feerepair": "0.00",
        			"feeother": "0.00",
        			"feesalary": "0.00",
        			"billmoney": "236016.66"
        		},
        		{
        			"taskmonth": "2024-04",
        			"taskcnt": "242",
        			"thingcnt": "5",
        			"plancnt": "242",
        			"doingcnt": "0",
        			"finishcnt": "242",
        			"startweightsum": "7863.77",
        			"finishweightsum": "42791.46",
        			"feerepair": "0.00",
        			"feeother": "0.00",
        			"feesalary": "0.00",
        			"billmoney": "65140.85"
        		},
        		{
        			"taskmonth": "2024-05",
        			"taskcnt": "263",
        			"thingcnt": "9",
        			"plancnt": "263",
        			"doingcnt": "0",
        			"finishcnt": "263",
        			"startweightsum": "8449.67",
        			"finishweightsum": "8368.68",
        			"feerepair": "0.00",
        			"feeother": "0.00",
        			"feesalary": "0.00",
        			"billmoney": "125395.59"
        		},
        		{
        			"taskmonth": "2024-06",
        			"taskcnt": "250",
        			"thingcnt": "6",
        			"plancnt": "250",
        			"doingcnt": "0",
        			"finishcnt": "250",
        			"startweightsum": "8236.51",
        			"finishweightsum": "8170.68",
        			"feerepair": "0.00",
        			"feeother": "0.00",
        			"feesalary": "0.00",
        			"billmoney": "132227.46"
        		},
        		{
        			"taskmonth": "2024-07",
        			"taskcnt": "1121",
        			"thingcnt": "101",
        			"plancnt": "1121",
        			"doingcnt": "1",
        			"finishcnt": "1120",
        			"startweightsum": "37462.29",
        			"finishweightsum": "37171.84",
        			"feerepair": "0.00",
        			"feeother": "727.96",
        			"feesalary": "0.00",
        			"billmoney": "235756.05"
        		},
        		{
        			"taskmonth": "2024-08",
        			"taskcnt": "8243",
        			"thingcnt": "154",
        			"plancnt": "8243",
        			"doingcnt": "2",
        			"finishcnt": "8241",
        			"startweightsum": "275741.83",
        			"finishweightsum": "33307.03",
        			"feerepair": "0.00",
        			"feeother": "3746.58",
        			"feesalary": "0.00",
        			"billmoney": "640411.91"
        		},
        		{
        			"taskmonth": "2024-09",
        			"taskcnt": "2143",
        			"thingcnt": "153",
        			"plancnt": "2143",
        			"doingcnt": "28",
        			"finishcnt": "2115",
        			"startweightsum": "70774.26",
        			"finishweightsum": "69373.84",
        			"feerepair": "0.00",
        			"feeother": "261.11",
        			"feesalary": "0.00",
        			"billmoney": "54613.46"
        		}
        	]
        }
    }else if(obj=='thinglist'){
        
        list=[
        		{
        			"truckid": "608",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307069",
        			"username": "施伟龙",
        			"licenseplatenumber": "湘K12906D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W0R3002571",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/e56309b48f7e7d6bb66f4839d4af7671.jpg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/4ba8f826746485082c1ed8dc09a42e70.jpg",
        			"licenseexpiredate": "2025-04-30",
        			"licenseissuedate": "2024-04-18",
        			"licenseregisterdate": "2024-04-18",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211281",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/khy/2024/08/28/4259e62261dfda8f1d8bf97769a91f47.jpg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2027-04-25",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-18",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KB816挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/09a095f95ff87bd1bdcdece71cad7380.jpg",
        			"truckaxles": "6轴",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724831969",
        			"dateline": "1713764524",
        			"modifytime": "1725699229",
        			"operateuid": "307069",
        			"operateuname": "18207439110",
        			"thingid": "791",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "5",
        			"thingteam": "聂崎嵘",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K12906D",
        			"thingregnum": "12906",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674907",
        			"outcardno": "",
        			"thingvin": "LFXAH76W0R3002571",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "施伟龙",
        			"staffmobile": "18207439110",
        			"taskid": "0",
        			"tasknum": "236",
        			"leavestatus": "0",
        			"thingstatus": "18",
        			"applystatus": "0",
        			"operatemsg": "已装货发车",
        			"vehiclelng": "112.601415",
        			"vehiclelat": "25.268231",
        			"vehicleheight": "24",
        			"vehiclespeed": "14.00",
        			"vehicledirection": "105",
        			"vehiclemileage": "22180.8",
        			"vehiclewarn": "262148",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165605",
        			"todaymileage": "286.8",
        			"vehicleonline": "1",
        			"usermobile": "18207439110",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1178",
        					"userid": "307069",
        					"username": "18207439110",
        					"staffname": "施伟龙",
        					"staffmobile": "18207439110",
        					"thingid": "791"
        				}
        			]
        		},
        		{
        			"truckid": "625",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307075",
        			"username": "李海波",
        			"licenseplatenumber": "湘K18056D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W2R3002572",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/6f1b481655bb35de912f88125292aec9.jpeg",
        			"licensesideimage": "",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2024-04-18",
        			"licenseregisterdate": "2024-04-18",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211297",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/1690e3433ca1397d2b6a688270a41b4c.jpeg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2027-04-25",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-04",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KR990挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/81939d3a7d01b62915e64895670e3443.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724810673",
        			"dateline": "1713764524",
        			"modifytime": "1725699182",
        			"operateuid": "307075",
        			"operateuname": "151****9878",
        			"thingid": "797",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "5",
        			"thingteam": "聂崎嵘",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K18056D",
        			"thingregnum": "18056",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674929",
        			"outcardno": "",
        			"thingvin": "LFXAH76W2R3002572",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "李海波",
        			"staffmobile": "15115689878",
        			"taskid": "0",
        			"tasknum": "236",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.601415",
        			"vehiclelat": "25.268231",
        			"vehicleheight": "26",
        			"vehiclespeed": "57.00",
        			"vehicledirection": "269",
        			"vehiclemileage": "33668.1",
        			"vehiclewarn": "262144",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165607",
        			"todaymileage": "291.1",
        			"vehicleonline": "1",
        			"usermobile": "15115689878",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1182",
        					"userid": "307075",
        					"username": "15115689878",
        					"staffname": "李海波",
        					"staffmobile": "15115689878",
        					"thingid": "797"
        				}
        			]
        		},
        		{
        			"truckid": "340",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "305692",
        			"username": "覃委",
        			"licenseplatenumber": "湘K01738D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96WXN3003492",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/c9aec75b92472f429ab8c6af62c248b3.png",
        			"licensesideimage": "",
        			"licenseexpiredate": "2023-12-29",
        			"licenseissuedate": "2022-12-30",
        			"licenseregisterdate": "2022-12-30",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209664",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2023/05/khy/57933e31-3c3e-40e3-9227-89c4114a8ec7.jpg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2026-03-28",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-04",
        			"inspectionenddate": "2024-12-31",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "11700",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KR276挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/72bbf89e39709735752abd5cc8e6da66.jpg",
        			"truckaxles": "6轴",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724812445",
        			"dateline": "1678693585",
        			"modifytime": "1725699152",
        			"operateuid": "305692",
        			"operateuname": "15616088937",
        			"thingid": "340",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "D29",
        			"thingregcode": "湘K01738D",
        			"thingregnum": "01738",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64848679897",
        			"outcardno": "0000002694871193",
        			"thingvin": "LFCAH96WXN3003492",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "覃委",
        			"staffmobile": "15616088937",
        			"taskid": "0",
        			"tasknum": "208",
        			"leavestatus": "0",
        			"thingstatus": "20",
        			"applystatus": "0",
        			"operatemsg": "【结算平台】同步卸货",
        			"vehiclelng": "112.601415",
        			"vehiclelat": "25.268231",
        			"vehicleheight": "23",
        			"vehiclespeed": "7.60",
        			"vehicledirection": "70",
        			"vehiclemileage": "169506.3",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165602",
        			"todaymileage": "309.8",
        			"vehicleonline": "1",
        			"usermobile": "15616088937",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1003",
        					"userid": "305692",
        					"username": "15616088937",
        					"staffname": "覃委",
        					"staffmobile": "15616088937",
        					"thingid": "340"
        				}
        			]
        		},
        		{
        			"truckid": "439",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307083",
        			"username": "易建成",
        			"licenseplatenumber": "湘K01889D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W0N3003551",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/a7d801cf1e174b668f6dc0370e9237a5.png",
        			"licensesideimage": "",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-21",
        			"licenseregisterdate": "2022-12-21",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209722",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/a0ba7319c9ca34f84b4803cc81a5422c.jpg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2026-04-02",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-21",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘K9083挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "None",
        			"truckaxles": "None",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1678693585",
        			"modifytime": "1725699149",
        			"operateuid": "307083",
        			"operateuname": "134****9173",
        			"thingid": "348",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K01889D",
        			"thingregnum": "01889",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64846214914",
        			"outcardno": "",
        			"thingvin": "LFCAH96W0N3003551",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "易建成",
        			"staffmobile": "13467889173",
        			"taskid": "0",
        			"tasknum": "225",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.601415",
        			"vehiclelat": "25.268231",
        			"vehicleheight": "116",
        			"vehiclespeed": "53.10",
        			"vehicledirection": "67",
        			"vehiclemileage": "141052.1",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165603",
        			"todaymileage": "237.7",
        			"vehicleonline": "1",
        			"usermobile": "13467889173",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1146",
        					"userid": "307083",
        					"username": "13467889173",
        					"staffname": "易建成",
        					"staffmobile": "13467889173",
        					"thingid": "348"
        				}
        			]
        		},
        		{
        			"truckid": "725",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307569",
        			"username": "李正军",
        			"licenseplatenumber": "湘K00285D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LRDS6P5C2RR003032",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/60031d8a4f16f6bd5fab3eb13f2cc401.jpg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/d9bc4ed30d819d630b0d49473d07d097.jpg",
        			"licenseexpiredate": "2039-06-07",
        			"licenseissuedate": "2024-06-07",
        			"licenseregisterdate": "2024-06-07",
        			"licenseissueorgname": "娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211568",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/13237774938045c9a85c8a4ff3ae38e0.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/13237774938045c9a85c8a4ff3ae38e0.jpg",
        			"transportvalidenddate": "2027-06-12",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": null,
        			"inspectionenddate": "2025-06-30",
        			"usenature": "货运",
        			"loadweight": "38070",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10800",
        			"outlinelength": "7490",
        			"outlinewidth": "2550",
        			"outlineheight": "3100",
        			"trailerplatenumber": "湘KT926挂",
        			"trailertypecode": "B11",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/dd4c261370ac9bde95f143bd9ae9b6dc.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724835751",
        			"dateline": "1723607033",
        			"modifytime": "1725699101",
        			"operateuid": "307569",
        			"operateuname": "185****6722",
        			"thingid": "950",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "5",
        			"thingteam": "聂崎嵘",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K00285D",
        			"thingregnum": "00285",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": null,
        			"outcardno": "",
        			"thingvin": "LRDS6P5C2RR003032",
        			"trailercode": null,
        			"thington": "38.070",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "李正军",
        			"staffmobile": "18573856722",
        			"taskid": "22091",
        			"tasknum": "0",
        			"leavestatus": "0",
        			"thingstatus": "15",
        			"applystatus": "0",
        			"operatemsg": "货运司机已接单",
        			"vehiclelng": null,
        			"vehiclelat": null,
        			"vehicleheight": null,
        			"vehiclespeed": null,
        			"vehicledirection": null,
        			"vehiclemileage": null,
        			"vehiclewarn": null,
        			"vehicleduration": null,
        			"vehicledate": null,
        			"todaymileage": "0",
        			"vehicleonline": "0",
        			"usermobile": "18573856722",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1288",
        					"userid": "307569",
        					"username": "185****6722",
        					"staffname": "李正军",
        					"staffmobile": "18573856722",
        					"thingid": "950"
        				}
        			]
        		},
        		{
        			"truckid": "341",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "300736",
        			"username": "王立军",
        			"licenseplatenumber": "湘K11567D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W2N3003583",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/b96bef7cb538656c9a9f7df3a5d88f58.png",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/49c3502bc8269dcad32ad449d60ba2f9.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-22",
        			"licenseregisterdate": "2022-12-22",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209659",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/8b3096ce409b9eba20ff8ad14c2f7e09.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/950bd0621462a7c1186c49c6d4904920.jpg",
        			"transportvalidenddate": "2026-03-28",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-04",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KB697挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/7c29d975af9a55f43b7480d312a1acfb.jpg",
        			"truckaxles": "None",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747656",
        			"dateline": "1678693585",
        			"modifytime": "1725699083",
        			"operateuid": "300736",
        			"operateuname": "138****6311",
        			"thingid": "341",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K11567D",
        			"thingregnum": "11567",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64846215013",
        			"outcardno": "",
        			"thingvin": "LFCAH96W2N3003583",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "138****6311",
        			"staffmobile": "13875856311",
        			"taskid": "0",
        			"tasknum": "218",
        			"leavestatus": "0",
        			"thingstatus": "18",
        			"applystatus": "0",
        			"operatemsg": "已装货发车",
        			"vehiclelng": "112.601415",
        			"vehiclelat": "25.268231",
        			"vehicleheight": "23",
        			"vehiclespeed": "63.00",
        			"vehicledirection": "21",
        			"vehiclemileage": "167786.7",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165540",
        			"todaymileage": "370.0",
        			"vehicleonline": "1",
        			"usermobile": "13875856311",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "684",
        					"userid": "300736",
        					"username": "13875856311",
        					"staffname": "王立军",
        					"staffmobile": "13875856311",
        					"thingid": "341"
        				}
        			]
        		},
        		{
        			"truckid": "392",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "299930",
        			"username": "易育强",
        			"licenseplatenumber": "湘K19369D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W2N3003518",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/4686de9ebd04b2b59ce1664b6c80edbf.png",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/d4b9d0d48adc0b58688bb5c31ce06c79.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-22",
        			"licenseregisterdate": "2022-12-22",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209641",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/dbb368f22a0ded2a505d84686237538d.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/6e9a93066c64532c19247941562c9cf6.jpg",
        			"transportvalidenddate": "2026-03-27",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-22",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KY029挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "None",
        			"truckaxles": "None",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1678693585",
        			"modifytime": "1725699041",
        			"operateuid": "299930",
        			"operateuname": "186****0847",
        			"thingid": "392",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K19369D",
        			"thingregnum": "19369",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64846237177",
        			"outcardno": "0000001623187097",
        			"thingvin": "LFCAH96W2N3003518",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "易育强",
        			"staffmobile": "18627610847",
        			"taskid": "0",
        			"tasknum": "226",
        			"leavestatus": "0",
        			"thingstatus": "18",
        			"applystatus": "0",
        			"operatemsg": "已装货发车",
        			"vehiclelng": "112.601415",
        			"vehiclelat": "25.268231",
        			"vehicleheight": "350",
        			"vehiclespeed": "17.70",
        			"vehicledirection": "229",
        			"vehiclemileage": "166853.4",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165554",
        			"todaymileage": "286.2",
        			"vehicleonline": "1",
        			"usermobile": "18627610847",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "648",
        					"userid": "299930",
        					"username": "18627610847",
        					"staffname": "易育强",
        					"staffmobile": "18627610847",
        					"thingid": "392"
        				}
        			]
        		},
        		{
        			"truckid": "551",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307152",
        			"username": "金波",
        			"licenseplatenumber": "湘K11989D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W7N3003580",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/6cab437c6a5f8700cbe07fbdba98d0c3.png",
        			"licensesideimage": "undefined",
        			"licenseexpiredate": "2035-08-26",
        			"licenseissuedate": "2022-12-22",
        			"licenseregisterdate": "2022-12-22",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209647",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/404daa711c052ba918725ffa1c62905b.jpg",
        			"transportlicenseside": "undefined",
        			"transportvalidenddate": "2026-03-27",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-22",
        			"inspectionenddate": "2024-12-31",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KA880挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/cccaadfe7c03563f259bee874e0b3d5d.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1678693585",
        			"modifytime": "1725698954",
        			"operateuid": "307152",
        			"operateuname": "189****1198",
        			"thingid": "372",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "D61",
        			"thingregcode": "湘K11989D",
        			"thingregnum": "11989",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64846239423",
        			"outcardno": "0000002425426074",
        			"thingvin": "LFCAH96W7N3003580",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "189****1198",
        			"staffmobile": "18974981198",
        			"taskid": "22084",
        			"tasknum": "230",
        			"leavestatus": "0",
        			"thingstatus": "18",
        			"applystatus": "0",
        			"operatemsg": "已装货发车",
        			"vehiclelng": "112.968081",
        			"vehiclelat": "27.931933",
        			"vehicleheight": "33",
        			"vehiclespeed": "53.60",
        			"vehicledirection": "50",
        			"vehiclemileage": "147568.5",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165539",
        			"todaymileage": "320.6",
        			"vehicleonline": "1",
        			"useravatar": "1724664099",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2024/08/01/307152_17225178789603.jpg?x-oss-process=style/common",
        			"usermobile": "18974981198",
        			"useravatar_small": "avatar/user/000/30/71/52_small.jpg?t=1724664099",
        			"useravatar_middle": "avatar/user/000/30/71/52_middle.jpg?t=1724664099",
        			"stafflist": [
        				{
        					"staffid": "1197",
        					"userid": "307152",
        					"username": "18974981198",
        					"staffname": "金波",
        					"staffmobile": "18974981198",
        					"thingid": "372"
        				}
        			]
        		},
        		{
        			"truckid": "568",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307309",
        			"username": "文鹏程",
        			"licenseplatenumber": "湘K05685D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W2R3002569",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/e16cac1fc80c56ff25a5be57b855a1cd.jpeg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/acabea70af5c18c934aa3c813491360a.jpeg",
        			"licenseexpiredate": "2039-04-17",
        			"licenseissuedate": "2024-04-17",
        			"licenseregisterdate": "2024-04-17",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211242",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/dbf399f1afe459a3cb64fdadfa6053f5.jpeg",
        			"transportlicenseside": "undefined",
        			"transportvalidenddate": "2027-04-23",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-03",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KF289挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/6c80a33cf84932a8df33d21561fb1ba4.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1725001638",
        			"dateline": "1713764524",
        			"modifytime": "1725698928",
        			"operateuid": "307309",
        			"operateuname": "18373780789",
        			"thingid": "771",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "5",
        			"thingteam": "聂崎嵘",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K05685D",
        			"thingregnum": "05685",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674904",
        			"outcardno": "",
        			"thingvin": "LFXAH76W2R3002569",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "文鹏程",
        			"staffmobile": "18373780789",
        			"taskid": "22087",
        			"tasknum": "239",
        			"leavestatus": "0",
        			"thingstatus": "15",
        			"applystatus": "0",
        			"operatemsg": "货运司机已接单",
        			"vehiclelng": "112.317672",
        			"vehiclelat": "28.151400",
        			"vehicleheight": "142",
        			"vehiclespeed": "0.00",
        			"vehicledirection": "0",
        			"vehiclemileage": "26832.3",
        			"vehiclewarn": "262144",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165557",
        			"todaymileage": "358.8",
        			"vehicleonline": "1",
        			"usermobile": "18373780789",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1250",
        					"userid": "307309",
        					"username": "18373780789",
        					"staffname": "文鹏程",
        					"staffmobile": "18373780789",
        					"thingid": "771"
        				}
        			]
        		},
        		{
        			"truckid": "387",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "299629",
        			"username": "刘军",
        			"licenseplatenumber": "湘K18017D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W0N3003548",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/5b6632621bbef936d390377c206d215b.png",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/3b4809d2a0b6e05273d6463380e57591.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-21",
        			"licenseregisterdate": "2022-12-21",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209640",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/022d3e833fd8edea6295c5fa9cd18954.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/d4265e5f815c4161a46d4342f549887f.jpg",
        			"transportvalidenddate": "2026-03-27",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-21",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KL963挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/b4558d83dd96a36fac96ddf442faf955.jpg",
        			"truckaxles": "None",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1678693585",
        			"modifytime": "1725698812",
        			"operateuid": "299629",
        			"operateuname": "189****8766",
        			"thingid": "387",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K18017D",
        			"thingregnum": "18017",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64846220128",
        			"outcardno": "0000000547868057",
        			"thingvin": "LFCAH96W0N3003548",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "189****8766",
        			"staffmobile": "18973898766",
        			"taskid": "0",
        			"tasknum": "231",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "111.691636",
        			"vehiclelat": "27.779120",
        			"vehicleheight": "164",
        			"vehiclespeed": "0.00",
        			"vehicledirection": "0",
        			"vehiclemileage": "157914.4",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165104",
        			"todaymileage": "263.4",
        			"vehicleonline": "1",
        			"usermobile": "18973898766",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "629",
        					"userid": "299629",
        					"username": "18973898766",
        					"staffname": "刘军",
        					"staffmobile": "18973898766",
        					"thingid": "387"
        				}
        			]
        		},
        		{
        			"truckid": "706",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307033",
        			"username": "谢卫红",
        			"licenseplatenumber": "湘K09836D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W1R3002689",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/fee0a51a32d9246241ce8991a1f754bd.jpg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/a02a822d6ea9e1a1593c0c05d637d139.jpg",
        			"licenseexpiredate": "2039-05-22",
        			"licenseissuedate": "2024-05-22",
        			"licenseregisterdate": "2024-05-22",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211475",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/dc26d32644243d1853daa1a75e5e1bba.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/dc26d32644243d1853daa1a75e5e1bba.jpg",
        			"transportvalidenddate": "2027-05-26",
        			"trucktypecode": "H17",
        			"platecolor": "1",
        			"energytype": "C",
        			"registerdate": "2024-06-19",
        			"inspectionenddate": "2025-05-31",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KJ962挂",
        			"trailertypecode": "",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/55c85044739bf878e4052d90039ac240.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1716969592",
        			"modifytime": "1725698456",
        			"operateuid": "307033",
        			"operateuname": "13873158589",
        			"thingid": "887",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "5",
        			"thingteam": "聂崎嵘",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K09836D",
        			"thingregnum": "09836",
        			"thingpower": "2",
        			"thingcat": "重型自卸货车",
        			"vehiclecode": "42055906988",
        			"outcardno": "",
        			"thingvin": "LFXAH76W1R3002689",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "138****8589",
        			"staffmobile": "13873158589",
        			"taskid": "22087",
        			"tasknum": "231",
        			"leavestatus": "0",
        			"thingstatus": "18",
        			"applystatus": "0",
        			"operatemsg": "已装货发车",
        			"vehiclelng": "111.975627",
        			"vehiclelat": "27.769011",
        			"vehicleheight": "118",
        			"vehiclespeed": "0.00",
        			"vehicledirection": "0",
        			"vehiclemileage": "28163.3",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165542",
        			"todaymileage": "335.9",
        			"vehicleonline": "1",
        			"usermobile": "13873158589",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1220",
        					"userid": "307033",
        					"username": "13873158589",
        					"staffname": "谢卫红",
        					"staffmobile": "13873158589",
        					"thingid": "887"
        				}
        			]
        		},
        		{
        			"truckid": "616",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307110",
        			"username": "彭余辉",
        			"licenseplatenumber": "湘K16276D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W4R3002573",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/a3ca95e08d25cf19e08210365f4ee955.jpg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/e9c80c74ec7fc8230d384502833e9972.jpg",
        			"licenseexpiredate": "",
        			"licenseissuedate": "2024-04-18",
        			"licenseregisterdate": "2024-04-18",
        			"licenseissueorgname": "娄底公安局",
        			"roadtransportnumber": "431382211280",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/3d59751b677442c8318db02d2c3f7cd3.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/1ac8abfa6309daf3e11350e779bab60d.jpg",
        			"transportvalidenddate": "2027-04-25",
        			"trucktypecode": "Q11",
        			"platecolor": "1",
        			"energytype": "C",
        			"registerdate": "2024-06-03",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KP852挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "瑞麟物流",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/ab9c3fb5b64525059133966c6e600c93.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "3",
        			"auditmsg": null,
        			"audittime": "1724746692",
        			"dateline": "1713764524",
        			"modifytime": "1725698391",
        			"operateuid": "274028",
        			"operateuname": "19911534004",
        			"thingid": "793",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "10",
        			"thingteam": "七星",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K16276D",
        			"thingregnum": "16276",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674936",
        			"outcardno": "",
        			"thingvin": "LFXAH76W4R3002573",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "彭余辉",
        			"staffmobile": "18073360850",
        			"taskid": "0",
        			"tasknum": "230",
        			"leavestatus": "0",
        			"thingstatus": "18",
        			"applystatus": "0",
        			"operatemsg": "已装货发车",
        			"vehiclelng": "111.578719",
        			"vehiclelat": "28.189419",
        			"vehicleheight": "450",
        			"vehiclespeed": "24.00",
        			"vehicledirection": "215",
        			"vehiclemileage": "19242.8",
        			"vehiclewarn": "262148",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165601",
        			"todaymileage": "294.8",
        			"vehicleonline": "1",
        			"usermobile": "18073360850",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1156",
        					"userid": "307110",
        					"username": "18073360850",
        					"staffname": "彭余辉",
        					"staffmobile": "18073360850",
        					"thingid": "793"
        				}
        			]
        		},
        		{
        			"truckid": "724",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "306885",
        			"username": "李荣",
        			"licenseplatenumber": "湘K10833D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W3R3002712",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/5ed27abaaceb27d89c16bcda997bb65c.jpg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/bd1ce817cdda12a096ae008f203b8b31.jpg",
        			"licenseexpiredate": "2039-05-24",
        			"licenseissuedate": "2024-05-24",
        			"licenseregisterdate": "2024-05-24",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211501",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/09c620b53010793fd79c3cdb701feddb.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/09c620b53010793fd79c3cdb701feddb.jpg",
        			"transportvalidenddate": "2027-05-28",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": null,
        			"inspectionenddate": "2025-05-31",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KD965挂",
        			"trailertypecode": "",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/37a5cc15829c5eb9492dfff910f0d59b.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1716970822",
        			"modifytime": "1725698320",
        			"operateuid": "306885",
        			"operateuname": "134****7769",
        			"thingid": "898",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "10",
        			"thingteam": "七星",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K10833D",
        			"thingregnum": "10833",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "42055906977",
        			"outcardno": "",
        			"thingvin": "LFXAH76W3R3002712",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "134****7769",
        			"staffmobile": "13450597769",
        			"taskid": "22105",
        			"tasknum": "232",
        			"leavestatus": "0",
        			"thingstatus": "18",
        			"applystatus": "0",
        			"operatemsg": "已装货发车",
        			"vehiclelng": "111.859836",
        			"vehiclelat": "27.926102",
        			"vehicleheight": "212",
        			"vehiclespeed": "22.00",
        			"vehicledirection": "255",
        			"vehiclemileage": "21500.8",
        			"vehiclewarn": "262144",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165610",
        			"todaymileage": "408.2",
        			"vehicleonline": "1",
        			"usermobile": "13450597769",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1154",
        					"userid": "306885",
        					"username": "13450597769",
        					"staffname": "李荣",
        					"staffmobile": "13450597769",
        					"thingid": "898"
        				}
        			]
        		},
        		{
        			"truckid": "379",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307353",
        			"username": "罗兰田",
        			"licenseplatenumber": "湘K15629D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W7N3003725",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/ce4bf5609c99afcc4b1eb37ee36c79e9.png",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/c9a4c89fa2577942668dc2d445fa5e51.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-30",
        			"licenseregisterdate": "2022-12-30",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209653",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/5ea9ab1632ddd1e701ad32fefb009815.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/bbe8c8c17a31293759fad375f5e91a26.jpg",
        			"transportvalidenddate": "2026-03-27",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-30",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KX077挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "None",
        			"truckaxles": "None",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1678693585",
        			"modifytime": "1725698196",
        			"operateuid": "307353",
        			"operateuname": "19918805088",
        			"thingid": "379",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K15629D",
        			"thingregnum": "15629",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64848676983",
        			"outcardno": "0000001883391130",
        			"thingvin": "LFCAH96W7N3003725",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "罗兰田",
        			"staffmobile": "19918805088",
        			"taskid": "0",
        			"tasknum": "212",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.981793",
        			"vehiclelat": "28.008236",
        			"vehicleheight": "45",
        			"vehiclespeed": "38.00",
        			"vehicledirection": "152",
        			"vehiclemileage": "159113.4",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165558",
        			"todaymileage": "349.0",
        			"vehicleonline": "1",
        			"usermobile": "19918805088",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1257",
        					"userid": "307353",
        					"username": "19918805088",
        					"staffname": "罗兰田",
        					"staffmobile": "19918805088",
        					"thingid": "379"
        				}
        			]
        		},
        		{
        			"truckid": "605",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307176",
        			"username": "阳范超",
        			"licenseplatenumber": "湘K11056D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W0R3002585",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/37918804febeb60743c1d151e73c2e56.jpeg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/403fbe4008d503903840cfc2dff8c376.jpeg",
        			"licenseexpiredate": "",
        			"licenseissuedate": "2024-04-18",
        			"licenseregisterdate": "2024-04-18",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211252",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/d90e7773030bb66f6bd61e6226684f75.jpeg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2027-04-24",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-03",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘K8818挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/e9d5e478de67ad85cd81897513b251e0.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724838831",
        			"dateline": "1714033732",
        			"modifytime": "1725698179",
        			"operateuid": "307176",
        			"operateuname": "134****4862",
        			"thingid": "839",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "5",
        			"thingteam": "聂崎嵘",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K11056D",
        			"thingregnum": "11056",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674916",
        			"outcardno": "",
        			"thingvin": "LFXAH76W0R3002585",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "阳范超",
        			"staffmobile": "13434574862",
        			"taskid": "22087",
        			"tasknum": "231",
        			"leavestatus": "0",
        			"thingstatus": "18",
        			"applystatus": "0",
        			"operatemsg": "已装货发车",
        			"vehiclelng": "111.975569",
        			"vehiclelat": "27.769016",
        			"vehicleheight": "125",
        			"vehiclespeed": "0.00",
        			"vehicledirection": "0",
        			"vehiclemileage": "38609.0",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165436",
        			"todaymileage": "344.0",
        			"vehicleonline": "1",
        			"usermobile": "13434574862",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1212",
        					"userid": "307176",
        					"username": "13434574862",
        					"staffname": "阳范超",
        					"staffmobile": "13434574862",
        					"thingid": "839"
        				}
        			]
        		},
        		{
        			"truckid": "564",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307060",
        			"username": "李烈岳",
        			"licenseplatenumber": "湘K05065D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W5R3002582",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/b58dfccbef8a2202bab81473a3233dd4.jpeg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/b4e5dd8ec12872dfb2b46a6d89be72d5.jpeg",
        			"licenseexpiredate": "",
        			"licenseissuedate": "2024-04-22",
        			"licenseregisterdate": "2024-04-22",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211293",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/1a14ad80a5bfa30167a7ccbb4442d606.jpeg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/3e85bb6480594032e4c113540f302a36.jpg",
        			"transportvalidenddate": "2027-04-25",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-03",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KS636挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/ee6a3a1bf9211698da71d94b56ae66c5.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "3",
        			"auditmsg": null,
        			"audittime": "1724746692",
        			"dateline": "1714033732",
        			"modifytime": "1725697907",
        			"operateuid": "307060",
        			"operateuname": "173****3587",
        			"thingid": "847",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "10",
        			"thingteam": "七星",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K05065D",
        			"thingregnum": "05065",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674941",
        			"outcardno": "",
        			"thingvin": "LFXAH76W5R3002582",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "173****3587",
        			"staffmobile": "17363863587",
        			"taskid": "0",
        			"tasknum": "235",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.336163",
        			"vehiclelat": "28.176227",
        			"vehicleheight": "66",
        			"vehiclespeed": "62.00",
        			"vehicledirection": "23",
        			"vehiclemileage": "16105.5",
        			"vehiclewarn": "262144",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165603",
        			"todaymileage": "252.8",
        			"vehicleonline": "1",
        			"usermobile": "17363863587",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1204",
        					"userid": "307060",
        					"username": "17363863587",
        					"staffname": "李烈岳",
        					"staffmobile": "17363863587",
        					"thingid": "847"
        				}
        			]
        		},
        		{
        			"truckid": "345",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "305691",
        			"username": "王仕剑",
        			"licenseplatenumber": "湘K01626D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W1N3003493",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/2a934007ee0033384bcbafe98d019c0a.png",
        			"licensesideimage": "undefined",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-30",
        			"licenseregisterdate": "2022-12-30",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209721",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/d376430b7058c2d1276a7e14665dc0a5.jpg",
        			"transportlicenseside": "undefined",
        			"transportvalidenddate": "2026-04-02",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-30",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KK313挂",
        			"trailertypecode": "",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "None",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1678693585",
        			"modifytime": "1725697848",
        			"operateuid": "305691",
        			"operateuname": "19373871777",
        			"thingid": "345",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K01626D",
        			"thingregnum": "01626",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64821210109",
        			"outcardno": "00000010853449",
        			"thingvin": "LFCAH96W1N3003493",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "19373871777",
        			"staffmobile": "19373871777",
        			"taskid": "0",
        			"tasknum": "235",
        			"leavestatus": "0",
        			"thingstatus": "20",
        			"applystatus": "0",
        			"operatemsg": "已到达完成卸货",
        			"vehiclelng": "111.925555",
        			"vehiclelat": "27.690120",
        			"vehicleheight": "136",
        			"vehiclespeed": "13.10",
        			"vehicledirection": "318",
        			"vehiclemileage": "163976.0",
        			"vehiclewarn": "4",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165559",
        			"todaymileage": "301.6",
        			"vehicleonline": "1",
        			"usermobile": "19373871777",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1002",
        					"userid": "305691",
        					"username": "19373871777",
        					"staffname": "王仕剑",
        					"staffmobile": "19373871777",
        					"thingid": "345"
        				}
        			]
        		},
        		{
        			"truckid": "363",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307046",
        			"username": "廖勇",
        			"licenseplatenumber": "湘K06838D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W2N3003552",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/2bba7a5061d6e2e8a7355d123a7df2f1.png",
        			"licensesideimage": "",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-30",
        			"licenseregisterdate": "2022-12-30",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209669",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/182894f436d8962738e52d4a532236c6.jpg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2026-03-28",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-30",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KU565挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "None",
        			"truckaxles": "None",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1678693585",
        			"modifytime": "1725697766",
        			"operateuid": "307046",
        			"operateuname": "廖勇",
        			"thingid": "363",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K06838D",
        			"thingregnum": "06838",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64848675359",
        			"outcardno": "",
        			"thingvin": "LFCAH96W2N3003552",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "廖勇",
        			"staffmobile": "13807386887",
        			"taskid": "0",
        			"tasknum": "227",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "111.975313",
        			"vehiclelat": "27.769183",
        			"vehicleheight": "143",
        			"vehiclespeed": "0.00",
        			"vehicledirection": "0",
        			"vehiclemileage": "163027.9",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165410",
        			"todaymileage": "327.6",
        			"vehicleonline": "1",
        			"useravatar": "1721731597",
        			"useravatar_link": "https://thirdwx.qlogo.cn/mmopen/vi_32/hcyx42OR8I7bicJ0vrezJ4U49P9jaSyVLOyicosvk2p5Uic5nWuOAtuqnpL6U4cxl4yPrm1KzibXTQm7TzJSef7NHA/132",
        			"usermobile": "13807386887",
        			"useravatar_small": "avatar/user/000/30/70/46_small.jpg?t=1721731597",
        			"useravatar_middle": "avatar/user/000/30/70/46_middle.jpg?t=1721731597",
        			"stafflist": [
        				{
        					"staffid": "1137",
        					"userid": "307046",
        					"username": "廖勇",
        					"staffname": "廖勇",
        					"staffmobile": "13807386887",
        					"thingid": "363"
        				}
        			]
        		},
        		{
        			"truckid": "587",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307115",
        			"username": "邹国良",
        			"licenseplatenumber": "湘K08285D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W3R3002676",
        			"licensemainimage": "tgj168/image/2024/06/03/132846_17174063596704.jpg",
        			"licensesideimage": "tgj168/image/2024/06/03/132846_17174063636937.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2024-04-22",
        			"licenseregisterdate": "2024-04-22",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211310",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgj168/image/2024/05/29/189635_17169650747125.jpg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2027-04-27",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-03",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KS892挂",
        			"trailertypecode": "",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/20d9d14d6bf9227fb4d843fa3ea513c2.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1714033732",
        			"modifytime": "1725697687",
        			"operateuid": "307115",
        			"operateuname": "181****8918",
        			"thingid": "852",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "5",
        			"thingteam": "聂崎嵘",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K08285D",
        			"thingregnum": "08285",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674939",
        			"outcardno": "",
        			"thingvin": "LFXAH76W3R3002676",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "181****8918",
        			"staffmobile": "18175138918",
        			"taskid": "0",
        			"tasknum": "234",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.457625",
        			"vehiclelat": "28.391452",
        			"vehicleheight": "53",
        			"vehiclespeed": "48.00",
        			"vehicledirection": "185",
        			"vehiclemileage": "31292.2",
        			"vehiclewarn": "262144",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165558",
        			"todaymileage": "311.9",
        			"vehicleonline": "1",
        			"usermobile": "18175138918",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1249",
        					"userid": "307115",
        					"username": "18175138918",
        					"staffname": "邹国良",
        					"staffmobile": "18175138918",
        					"thingid": "852"
        				}
        			]
        		},
        		{
        			"truckid": "588",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307264",
        			"username": "沈裕",
        			"licenseplatenumber": "湘K08755D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W2R3002605",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/44e9b7361548075633f9f00dcb05ba86.jpg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/ff35a197e4277e6eaae0490c411904a2.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2024-04-22",
        			"licenseregisterdate": "2024-04-22",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211316",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/28f5483b45ba54eb468beb0ad787d474.jpg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2025-04-30",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-03",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KF268挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "None",
        			"truckaxles": "None",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1714033732",
        			"modifytime": "1725697500",
        			"operateuid": "307264",
        			"operateuname": "166****5484",
        			"thingid": "853",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "10",
        			"thingteam": "七星",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K08755D",
        			"thingregnum": "08755",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674943",
        			"outcardno": "",
        			"thingvin": "LFXAH76W2R3002605",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "沈裕",
        			"staffmobile": "16607395484",
        			"taskid": "0",
        			"tasknum": "239",
        			"leavestatus": "0",
        			"thingstatus": "18",
        			"applystatus": "0",
        			"operatemsg": "已装货发车",
        			"vehiclelng": "112.322330",
        			"vehiclelat": "28.161152",
        			"vehicleheight": "80",
        			"vehiclespeed": "69.00",
        			"vehicledirection": "40",
        			"vehiclemileage": "22271.5",
        			"vehiclewarn": "262144",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165556",
        			"todaymileage": "253.2",
        			"vehicleonline": "1",
        			"usermobile": "16607395484",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1242",
        					"userid": "307264",
        					"username": "16607395484",
        					"staffname": "沈裕",
        					"staffmobile": "16607395484",
        					"thingid": "853"
        				}
        			]
        		},
        		{
        			"truckid": "369",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "305698",
        			"username": "李浩",
        			"licenseplatenumber": "湘K10538D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W9N3002589",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/f58742fc1eec5bd9631ba468effafb30.png",
        			"licensesideimage": "",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-30",
        			"licenseregisterdate": "2022-12-30",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209643",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/b5f579ef816ff2f36e2f1a6b115cad2d.jpg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2026-03-27",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-30",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KB068挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "None",
        			"truckaxles": "None",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1678693585",
        			"modifytime": "1725697440",
        			"operateuid": "305698",
        			"operateuname": "186****8160",
        			"thingid": "369",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K10538D",
        			"thingregnum": "10538",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64846257640",
        			"outcardno": "0000001085677978",
        			"thingvin": "LFCAH96W9N3002589",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "李浩",
        			"staffmobile": "18673128160",
        			"taskid": "0",
        			"tasknum": "223",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.974743",
        			"vehiclelat": "27.938955",
        			"vehicleheight": "47",
        			"vehiclespeed": "61.60",
        			"vehicledirection": "232",
        			"vehiclemileage": "172894.1",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165601",
        			"todaymileage": "51.7",
        			"vehicleonline": "1",
        			"useravatar": "1721633442",
        			"useravatar_link": "https://img.tgj168.com/tgjffwl/2024/07/22/305698_17216334406343.jpg?x-oss-process=style/common",
        			"usermobile": "18673128160",
        			"useravatar_small": "avatar/user/000/30/56/98_small.jpg?t=1721633442",
        			"useravatar_middle": "avatar/user/000/30/56/98_middle.jpg?t=1721633442",
        			"stafflist": [
        				{
        					"staffid": "1009",
        					"userid": "305698",
        					"username": "18673128160",
        					"staffname": "李浩",
        					"staffmobile": "18673128160",
        					"thingid": "369"
        				}
        			]
        		},
        		{
        			"truckid": "572",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307125",
        			"username": "李金龙",
        			"licenseplatenumber": "湘K06515D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W6R3002560",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/04848a38966a3d165e4b34666b3f4bca.jpeg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/11b17f9ce18329285fcbd7d72b8becb5.jpeg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2024-04-18",
        			"licenseregisterdate": "2024-04-18",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211245",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/0355814a071de5c4c3e81f1777ed1ee9.jpeg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2027-04-23",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-14",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KK908挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/74582f3db90edbac856c6a433a945c04.jpg",
        			"truckaxles": "6轴",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1714033732",
        			"modifytime": "1725697435",
        			"operateuid": "307125",
        			"operateuname": "199****2399",
        			"thingid": "836",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K06515D",
        			"thingregnum": "06515",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674949",
        			"outcardno": "",
        			"thingvin": "LFXAH76W6R3002560",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "李金龙",
        			"staffmobile": "19907322399",
        			"taskid": "22084",
        			"tasknum": "222",
        			"leavestatus": "0",
        			"thingstatus": "15",
        			"applystatus": "0",
        			"operatemsg": "货运司机已接单",
        			"vehiclelng": "113.012227",
        			"vehiclelat": "27.970347",
        			"vehicleheight": "46",
        			"vehiclespeed": "51.00",
        			"vehicledirection": "338",
        			"vehiclemileage": "26665.7",
        			"vehiclewarn": "262148",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165608",
        			"todaymileage": "337.1",
        			"vehicleonline": "1",
        			"usermobile": "19907322399",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1173",
        					"userid": "307125",
        					"username": "19907322399",
        					"staffname": "李金龙",
        					"staffmobile": "19907322399",
        					"thingid": "836"
        				}
        			]
        		},
        		{
        			"truckid": "609",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307059",
        			"username": "隆海长",
        			"licenseplatenumber": "湘K13996D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W4R3002668",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/e6fe3de03d3923beaf45023c49a3cf58.jpeg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/f3b4e0c18d99cffbc62e6260e966a55f.jpeg",
        			"licenseexpiredate": "",
        			"licenseissuedate": "2024-04-18",
        			"licenseregisterdate": "2024-04-18",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211265",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/8ccd889d602e8b52a660370867859a12.jpeg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2027-04-24",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-03",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KV008挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/2c8d40082f32b6fed19b595e86222408.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724838063",
        			"dateline": "1713764524",
        			"modifytime": "1725697301",
        			"operateuid": "307059",
        			"operateuname": "134****1190",
        			"thingid": "792",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "10",
        			"thingteam": "七星",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K13996D",
        			"thingregnum": "13996",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674922",
        			"outcardno": "",
        			"thingvin": "LFXAH76W4R3002668",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "隆海长",
        			"staffmobile": "13487961190",
        			"taskid": "0",
        			"tasknum": "228",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.357411",
        			"vehiclelat": "28.193700",
        			"vehicleheight": "76",
        			"vehiclespeed": "47.00",
        			"vehicledirection": "73",
        			"vehiclemileage": "17721.3",
        			"vehiclewarn": "262144",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165557",
        			"todaymileage": "256.7",
        			"vehicleonline": "1",
        			"usermobile": "13487961190",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1209",
        					"userid": "307059",
        					"username": "13487961190",
        					"staffname": "隆海长",
        					"staffmobile": "13487961190",
        					"thingid": "792"
        				}
        			]
        		},
        		{
        			"truckid": "580",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307184",
        			"username": "肖勇",
        			"licenseplatenumber": "湘K07226D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W1R3002580",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/45500a872a8b3d420e738307ed07ed2f.jpg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/467c01f002aa35d6b3da0e6aff9ab55b.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2024-04-17",
        			"licenseregisterdate": "2024-04-17",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211261",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/269425c657feb448fe31e6889c39eeba.jpg",
        			"transportlicenseside": "undefined",
        			"transportvalidenddate": "2025-04-30",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-03",
        			"inspectionenddate": "2025-04-30",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KQ163挂",
        			"trailertypecode": "",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/a8da21faf41482abe893fbc8795e7cc5.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1713764524",
        			"modifytime": "1725697219",
        			"operateuid": "307184",
        			"operateuname": "139****9899",
        			"thingid": "772",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "10",
        			"thingteam": "七星",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K07226D",
        			"thingregnum": "07226",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "41619674932",
        			"outcardno": "",
        			"thingvin": "LFXAH76W1R3002580",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "13974119899",
        			"staffmobile": "13974119899",
        			"taskid": "0",
        			"tasknum": "238",
        			"leavestatus": "0",
        			"thingstatus": "20",
        			"applystatus": "0",
        			"operatemsg": "已到达完成卸货",
        			"vehiclelng": "111.875861",
        			"vehiclelat": "27.960805",
        			"vehicleheight": "291",
        			"vehiclespeed": "37.00",
        			"vehicledirection": "75",
        			"vehiclemileage": "26320.8",
        			"vehiclewarn": "262144",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165557",
        			"todaymileage": "362.1",
        			"vehicleonline": "1",
        			"usermobile": "13974119899",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1213",
        					"userid": "307184",
        					"username": "13974119899",
        					"staffname": "肖勇",
        					"staffmobile": "13974119899",
        					"thingid": "772"
        				}
        			]
        		},
        		{
        			"truckid": "373",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "300279",
        			"username": "杨波",
        			"licenseplatenumber": "湘K12956D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96WXN3003573",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/926f16a6d8ce3770efdd11d51b535838.png",
        			"licensesideimage": "undefined",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-21",
        			"licenseregisterdate": "2022-12-21",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209635",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/05cdb52b2d5fc40094545255435d4a84.jpg",
        			"transportlicenseside": "undefined",
        			"transportvalidenddate": "2026-03-27",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-21",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KW276挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/53f9eba2d32d25b08281a85becd0bff5.jpg",
        			"truckaxles": "6轴",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724814226",
        			"dateline": "1678693585",
        			"modifytime": "1725697094",
        			"operateuid": "300279",
        			"operateuname": "13958802469",
        			"thingid": "373",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K12956D",
        			"thingregnum": "12956",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64846194716",
        			"outcardno": "0000003763639705",
        			"thingvin": "LFCAH96WXN3003573",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "杨波",
        			"staffmobile": "13958802469",
        			"taskid": "0",
        			"tasknum": "222",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.950981",
        			"vehiclelat": "27.898691",
        			"vehicleheight": "30",
        			"vehiclespeed": "0.00",
        			"vehicledirection": "0",
        			"vehiclemileage": "160437.6",
        			"vehiclewarn": "4",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165550",
        			"todaymileage": "314.9",
        			"vehicleonline": "1",
        			"usermobile": "13958802469",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "661",
        					"userid": "300279",
        					"username": "13958802469",
        					"staffname": "杨波",
        					"staffmobile": "13958802469",
        					"thingid": "373"
        				}
        			]
        		},
        		{
        			"truckid": "362",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "293099",
        			"username": "龙中海",
        			"licenseplatenumber": "湘K06596D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W7N3002834",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/c9778278d0790840b721280d279ef7c4.png",
        			"licensesideimage": "tgjffwl/image/2024/09/khy/0d45ddfc689b30133e7ac10319cce924.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-30",
        			"licenseregisterdate": "2022-12-30",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209650",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/4a80d5fa5068c232955cfbad7630b71e.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/09/khy/85dc08e97939dda4071ebb4382a2306f.jpg",
        			"transportvalidenddate": "2026-03-27",
        			"trucktypecode": "Q11",
        			"platecolor": "93",
        			"energytype": "C",
        			"registerdate": "2022-12-30",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KH169挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/09/khy/62a37ff961202c1ecb39e78c5f4ae914.jpg",
        			"truckaxles": "None",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1725190116",
        			"dateline": "1678693585",
        			"modifytime": "1725697076",
        			"operateuid": "293099",
        			"operateuname": "龍????  海????",
        			"thingid": "362",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K06596D",
        			"thingregnum": "06596",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64821210340",
        			"outcardno": "0000000006099098",
        			"thingvin": "LFCAH96W7N3002834",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "龍????  海????",
        			"staffmobile": "17775778788",
        			"taskid": "0",
        			"tasknum": "226",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.963945",
        			"vehiclelat": "28.052225",
        			"vehicleheight": "22",
        			"vehiclespeed": "0.00",
        			"vehicledirection": "0",
        			"vehiclemileage": "151731.4",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907162625",
        			"todaymileage": "342.2",
        			"vehicleonline": "0",
        			"useravatar": "1717324204",
        			"useravatar_link": "https://thirdwx.qlogo.cn/mmopen/vi_32/UjZOlCWAJ0NouyOa72lA3U6qFQ9SXjwvTX9fAGdiczEaAMnKmewXYJoo31Ba4UmjMt1LR9dCSAkrVcqnHrw6Bow/132",
        			"usermobile": "17775778788",
        			"useravatar_small": "avatar/user/000/29/30/99_small.jpg?t=1717324204",
        			"useravatar_middle": "avatar/user/000/29/30/99_middle.jpg?t=1717324204",
        			"stafflist": [
        				{
        					"staffid": "329",
        					"userid": "293099",
        					"username": "17775778788",
        					"staffname": "龙中海",
        					"staffmobile": "17775778788",
        					"thingid": "362"
        				}
        			]
        		},
        		{
        			"truckid": "370",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "304438",
        			"username": "龙韶源",
        			"licenseplatenumber": "湘K11516D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W7N3003546",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/e6ec8296e3072f4595f56e76b193fb2b.png",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/0b4617cd8887c91b7daa1a598a55f1fa.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-21",
        			"licenseregisterdate": "2022-12-21",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209629",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/6c1d72a47473e722dd93baf0dbd8b7fa.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/b36eaa20a1e544fea2e80f7324a18bab.jpg",
        			"transportvalidenddate": "2026-03-27",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-21",
        			"inspectionenddate": "2024-12-31",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KF515挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/9bccc5d9557b0e4aaa6e775537fea7f7.jpg",
        			"truckaxles": "6轴",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724812676",
        			"dateline": "1678693585",
        			"modifytime": "1725696860",
        			"operateuid": "304438",
        			"operateuname": "18773280009",
        			"thingid": "370",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K11516D",
        			"thingregnum": "11516",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64846210588",
        			"outcardno": "0000000551414425",
        			"thingvin": "LFCAH96W7N3003546",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "龙韶源",
        			"staffmobile": "18773280009",
        			"taskid": "0",
        			"tasknum": "232",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "111.975396",
        			"vehiclelat": "27.769841",
        			"vehicleheight": "111",
        			"vehiclespeed": "0.00",
        			"vehicledirection": "0",
        			"vehiclemileage": "160173.7",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165536",
        			"todaymileage": "203.7",
        			"vehicleonline": "1",
        			"usermobile": "18773280009",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "985",
        					"userid": "304438",
        					"username": "18773280009",
        					"staffname": "龙韶源",
        					"staffmobile": "18773280009",
        					"thingid": "370"
        				}
        			]
        		},
        		{
        			"truckid": "349",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "299719",
        			"username": "李开颜",
        			"licenseplatenumber": "湘K02318D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W7N3003577",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/ec64c62ce62aae962199cb23c9a79c2a.jpg",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/4bdf831515c84800c76e13ce57079452.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-30",
        			"licenseregisterdate": "2022-12-30",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209630",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/aa2e35e98cffaaa37188d555767577aa.jpg",
        			"transportlicenseside": "",
        			"transportvalidenddate": "2026-03-27",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-30",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KY528挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/cc377eba9fafdc42ae2864672588b021.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "3",
        			"auditmsg": "[{\"checked\":false,\"custom\":false,\"item\":\"drivingLicenseMainFilename\",\"remarks\":\"行驶证正面照片有误\",\"result\":1},{\"checked\":true,\"custom\":true,\"remarks\":\"请上传行驶证带质量副页\"}]",
        			"audittime": "1724761160",
        			"dateline": "1678693585",
        			"modifytime": "1725696758",
        			"operateuid": "299719",
        			"operateuname": "189****3459",
        			"thingid": "349",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K02318D",
        			"thingregnum": "02318",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64848676775",
        			"outcardno": "0000000808422809",
        			"thingvin": "LFCAH96W7N3003577",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "李开颜",
        			"staffmobile": "18932433459",
        			"taskid": "0",
        			"tasknum": "229",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.995165",
        			"vehiclelat": "27.991198",
        			"vehicleheight": "32",
        			"vehiclespeed": "47.30",
        			"vehicledirection": "305",
        			"vehiclemileage": "161661.2",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165555",
        			"todaymileage": "334.4",
        			"vehicleonline": "1",
        			"usermobile": "18932433459",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "634",
        					"userid": "299719",
        					"username": "18932433459",
        					"staffname": "李开颜",
        					"staffmobile": "18932433459",
        					"thingid": "349"
        				}
        			]
        		},
        		{
        			"truckid": "386",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "305731",
        			"username": "张泽榕",
        			"licenseplatenumber": "湘K17998D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFCAH96W4N3003584",
        			"licensemainimage": "tgjffwl/image/2024/08/khy/146c444bcaa762bb24e031c73e37b8f3.png",
        			"licensesideimage": "tgjffwl/image/2024/08/khy/279320b8d478910287d81c8e3e7b8b93.jpg",
        			"licenseexpiredate": "1970-01-01",
        			"licenseissuedate": "2022-12-22",
        			"licenseregisterdate": "2022-12-22",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382209638",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/08/khy/ddf3b412bce78f395d1d08d1ac95e82e.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/08/khy/07de8ada691f741eed5dc5ba4bed7d2d.jpg",
        			"transportvalidenddate": "2026-03-27",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2022-12-22",
        			"inspectionenddate": "",
        			"usenature": "货运",
        			"loadweight": "37170",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "0",
        			"outlinelength": "7345",
        			"outlinewidth": "2545",
        			"outlineheight": "3715",
        			"trailerplatenumber": "湘KC106挂",
        			"trailertypecode": "B16",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/6cdc3f1042d265e035ecfdbe8a0252a4.jpg",
        			"truckaxles": "None",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1678693585",
        			"modifytime": "1725696395",
        			"operateuid": "305731",
        			"operateuname": "177****7116",
        			"thingid": "386",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "3",
        			"thingteam": "萧建春",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K17998D",
        			"thingregnum": "17998",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "64846230375",
        			"outcardno": "0000001883630489",
        			"thingvin": "LFCAH96W4N3003584",
        			"trailercode": null,
        			"thington": "37.170",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "177****7116",
        			"staffmobile": "17775157116",
        			"taskid": "22083",
        			"tasknum": "230",
        			"leavestatus": "0",
        			"thingstatus": "18",
        			"applystatus": "0",
        			"operatemsg": "已装货发车",
        			"vehiclelng": "112.119325",
        			"vehiclelat": "28.111120",
        			"vehicleheight": "141",
        			"vehiclespeed": "52.10",
        			"vehicledirection": "41",
        			"vehiclemileage": "163293.4",
        			"vehiclewarn": "0",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165602",
        			"todaymileage": "321.2",
        			"vehicleonline": "1",
        			"usermobile": "17775157116",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1016",
        					"userid": "305731",
        					"username": "17775157116",
        					"staffname": "张泽榕",
        					"staffmobile": "17775157116",
        					"thingid": "386"
        				}
        			]
        		},
        		{
        			"truckid": "705",
        			"businessid": "tgjffwl",
        			"corpid": "25",
        			"corpname": "货满满",
        			"userid": "307039",
        			"username": "陈杰",
        			"licenseplatenumber": "湘K18680D",
        			"truckowner": "涟源瑞麟智慧物流有限公司",
        			"identifycode": "LFXAH76W2R3002717",
        			"licensemainimage": "tgjffwl/image/2024/07/khy/f60ea7a13dfea252dcbf294c1c706be9.jpg",
        			"licensesideimage": "tgjffwl/image/2024/07/khy/c7b534fcfd65183471734d5b4ad6e2b8.jpg",
        			"licenseexpiredate": "2039-05-22",
        			"licenseissuedate": "2024-05-22",
        			"licenseregisterdate": "2024-05-22",
        			"licenseissueorgname": "湖南省娄底市公安局交通警察支队",
        			"roadtransportnumber": "431382211471",
        			"roadtransportpermitno": "431382204891",
        			"transportlicensemain": "tgjffwl/image/2024/07/khy/fdcf2e7982f119ea535c7d040f0f9cda.jpg",
        			"transportlicenseside": "tgjffwl/image/2024/07/khy/da462781698d8357d3844942a0213e4a.jpg",
        			"transportvalidenddate": "2027-05-26",
        			"trucktypecode": "Q11",
        			"platecolor": "5",
        			"energytype": "C",
        			"registerdate": "2024-06-19",
        			"inspectionenddate": "2025-05-31",
        			"usenature": "货运",
        			"loadweight": "38470",
        			"loadlength": "0.00",
        			"totalweight": "48870",
        			"curbweight": "10400",
        			"outlinelength": "7115",
        			"outlinewidth": "2545",
        			"outlineheight": "3150",
        			"trailerplatenumber": "湘KM185挂",
        			"trailertypecode": "",
        			"trailerloadweight": "0",
        			"businessholdsname": "涟源瑞麟智慧物流有限公司",
        			"carwithownerimage": "tgjffwl/image/2024/08/khy/68fa509a7375d8a8ca81d254aa6e71b3.jpg",
        			"truckaxles": "",
        			"truckstatus": "1",
        			"syncstatus": "1",
        			"auditstatus": "2",
        			"auditmsg": null,
        			"audittime": "1724747635",
        			"dateline": "1716969716",
        			"modifytime": "1725696338",
        			"operateuid": "307039",
        			"operateuname": "199****9888",
        			"thingid": "892",
        			"thingname": "三一",
        			"thingtype": "1",
        			"thingbrand": null,
        			"thingteamid": "5",
        			"thingteam": "聂崎嵘",
        			"placeid": "0",
        			"placename": "",
        			"thingbelongto": "涟源瑞麟智慧物流有限公司",
        			"thingboxtype": "",
        			"thingseqcode": "",
        			"thingregcode": "湘K18680D",
        			"thingregnum": "18680",
        			"thingpower": "2",
        			"thingcat": "重型半挂牵引车",
        			"vehiclecode": "42055906982",
        			"outcardno": "",
        			"thingvin": "LFXAH76W2R3002717",
        			"trailercode": null,
        			"thington": "38.470",
        			"thingimage": null,
        			"thingregdate": "",
        			"maplat": null,
        			"maplng": null,
        			"mapaddr": null,
        			"staffname": "19918379888",
        			"staffmobile": "19918379888",
        			"taskid": "0",
        			"tasknum": "236",
        			"leavestatus": "0",
        			"thingstatus": "5",
        			"applystatus": "0",
        			"operatemsg": "货运司机已完工",
        			"vehiclelng": "112.667180",
        			"vehiclelat": "28.159094",
        			"vehicleheight": "51",
        			"vehiclespeed": "89.00",
        			"vehicledirection": "291",
        			"vehiclemileage": "25113.6",
        			"vehiclewarn": "4",
        			"vehicleduration": "0.0",
        			"vehicledate": "20240907165557",
        			"todaymileage": "229.9",
        			"vehicleonline": "1",
        			"usermobile": "19918379888",
        			"useravatar_small": "images/avatar/no.jpg",
        			"useravatar_middle": "images/avatar/no.jpg",
        			"stafflist": [
        				{
        					"staffid": "1215",
        					"userid": "307039",
        					"username": "19918379888",
        					"staffname": "陈杰",
        					"staffmobile": "19918379888",
        					"thingid": "892"
        				}
        			]
        		},
        ]
    }
    
    
    if(type=='obj'){
        return data;
    }else{
        return list;
    }
         
}